// import React, { useState, useRef, useMemo, useEffect } from "react";
// import { Box, Button, Container, Typography, Snackbar, Alert, CircularProgress, LinearProgress, Card, CardContent, Grid, TextField, InputAdornment, Paper, Divider, Stack, IconButton, Collapse, alpha, Chip, Tooltip } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import * as XLSX from "xlsx";
// import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
// import SearchIcon from '@mui/icons-material/Search';
// import PersonIcon from '@mui/icons-material/Person';
// import PhoneIcon from '@mui/icons-material/Phone';
// import EmailIcon from '@mui/icons-material/Email';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import WarningIcon from '@mui/icons-material/Warning';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import ExpandLessIcon from '@mui/icons-material/ExpandLess';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import ErrorIcon from '@mui/icons-material/Error';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
// import SchoolIcon from '@mui/icons-material/School';
// import WorkIcon from '@mui/icons-material/Work';
// import { useAuth } from '../context/AuthContext';

// // Simple UUID-like ID generator for unique row IDs
// const generateUniqueId = () => {
//     return `row-${Math.random().toString(36).substr(2, 9)}-${Date.now().toString(36)}`;
// };

// // Styled Parent Card (Glass + Scroll)
// const GlassParentCard = ({ children }) => (
//     <Paper elevation={0} sx={{ borderRadius: 4, background: (theme) => alpha(theme.palette.background.paper, 0.8), backdropFilter: "blur(20px)", WebKitBackdropFilter: "blur(20px)", border: `1px solid ${(theme) => alpha(theme.palette.divider, 0.3)}`, [`& .MuiPaper-root`]: { borderRadius: 3 }, boxShadow: "0 16px 50px rgba(0,0,0,0.1)", position: "relative", overflow: "hidden", maxHeight: "78vh", display: "flex", flexDirection: "column", "&::before": { content: '""', position: "absolute", top: 0, left: 0, right: 0, height: 6, background: "linear-gradient(90deg, #1976d2, #42a5f5)", borderRadius: "16px 16px 0 0" } }} >
//         {children}
//     </Paper>
// );


// const parseAndFormatDate = (value) => {
//     if (!value) return "";

//     let dateObj = null;
//     let dateString = String(value).trim();

//     // Handle Date Objects (from Excel)
//     if (value instanceof Date) {
//         dateObj = value;
//     }
//     // Handle Excel Serial Numbers (e.g., 38141)
//     else if (typeof value === 'number' && value > 100 && value < 50000) {
//         const excelEpoch = new Date(1900, 0, 1);
//         dateObj = new Date(excelEpoch.getTime() + (value - 2) * 24 * 60 * 60 * 1000);
//     }
//     // Handle String Formats
//     else if (typeof dateString === 'string') {
//         dateString = dateString.trim();

//         const patterns = [
//             {
//                 regex: /^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/,
//                 dayIndex: 1,      // First number is DAY
//                 monthIndex: 2,    // Second number is MONTH
//                 yearIndex: 3      // Third number is YEAR
//             },
//             {
//                 regex: /^(\d{4})[\/\-](\d{1,2})[\/\-](\d{1,2})$/,
//                 dayIndex: 3,      // Third number is DAY
//                 monthIndex: 2,    // Second number is MONTH
//                 yearIndex: 1      // First number is YEAR
//             },
//         ];

//         for (const pattern of patterns) {
//             const match = dateString.match(pattern.regex);

//             if (match) {
//                 let day = parseInt(match[pattern.dayIndex], 10);
//                 let month = parseInt(match[pattern.monthIndex], 10);
//                 const year = parseInt(match[pattern.yearIndex], 10);

//                 // Validate month first (must be 1-12)
//                 if (month < 1 || month > 12) {
//                     continue;
//                 }

//                 const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

//                 if (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)) {
//                     daysInMonth[1] = 29; // February has 29 days in leap year
//                 }

//                 if (day < 1 || day > daysInMonth[month - 1]) {
//                     continue; // Invalid day for this month, try next pattern
//                 }

//                 dateObj = new Date(year, month - 1, day);
//                 break;
//             }
//         }

//         // Try parsing as generic date string (last resort)
//         if (!dateObj) {
//             const parsed = new Date(dateString);
//             if (!isNaN(parsed.getTime())) {
//                 dateObj = parsed;
//             }
//         }
//     }

//     // Format to DD-MM-YYYY
//     if (dateObj && !isNaN(dateObj.getTime())) {
//         const day = String(dateObj.getDate()).padStart(2, '0');
//         const month = String(dateObj.getMonth() + 1).padStart(2, '0');
//         const year = dateObj.getFullYear();
//         return `${day}-${month}-${year}`;
//     }

//     return dateString;
// };

// // Validate date is in DD-MM-YYYY format
// const isValidDateFormat = (dateStr) => {
//     if (!dateStr) return false;

//     // Check format: DD-MM-YYYY
//     const regex = /^(\d{2})-(\d{2})-(\d{4})$/;
//     const match = dateStr.match(regex);

//     if (!match) return false;

//     const day = parseInt(match[1], 10);
//     const month = parseInt(match[2], 10);
//     const year = parseInt(match[3], 10);

//     if (month < 1 || month > 12) return false;
//     if (day < 1 || day > 31) return false;
//     if (year < 1900 || year > 2100) return false;

//     // Validate day is correct for the month
//     const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
//     if (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)) {
//         daysInMonth[1] = 29;
//     }

//     if (day > daysInMonth[month - 1]) return false;

//     return true;
// };

// const isValidEmail = (email) => {
//     if (!email) return false;
//     return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
// };

// const isValidYear = (year) => {
//     if (!year) return false;
//     const numYear = Number(year);
//     const currentYear = new Date().getFullYear();
//     return /^\d{4}$/.test(year) && numYear >= 1900 && numYear <= currentYear;
// };

// const hasAnyFieldData = (record, fieldKeys) => {
//     return fieldKeys.some(key => record[key] && String(record[key]).trim() !== '');
// };

// const allFieldsHaveData = (record, fieldKeys) => {
//     return fieldKeys.every(key => record[key] && String(record[key]).trim() !== '');
// };

// const isEmpty = (value) => !value || String(value).trim() === '';

// // ===== MAIN COMPONENT =====
// const InsertCandidate = ({ connectionString }) => {
//     const { user, selectedCompany, loading } = useAuth();
//     const path = connectionString;
//     const navigate = useNavigate();
//     const fileInputRef = useRef(null);
//     const [file, setFile] = useState(null);
//     const [data, setData] = useState([]);
//     const [filteredData, setFilteredData] = useState([]);
//     const [uploading, setUploading] = useState(false);
//     const [uploadProgress, setUploadProgress] = useState(0);
//     const [progressValue, setProgressValue] = useState(0);
//     const [bufferValue, setBufferValue] = useState(0);
//     const [showBuffer, setShowBuffer] = useState(false);
//     const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
//     const [searchText, setSearchText] = useState("");
//     const [expandedCards, setExpandedCards] = useState({});
//     const [filterMode, setFilterMode] = useState('all');
//     const [insertedIds, setInsertedIds] = useState(new Set());
//     const [fadeOutIds, setFadeOutIds] = useState(new Set());
//     const [rowStatus, setRowStatus] = useState({});

//     const toggleExpand = (id) => setExpandedCards(prev => ({ ...prev, [id]: !prev[id] }));

//     console.log("InsertCandidate props:", { user, selectedCompany, connectionString });

//     const companyId = selectedCompany?.CompId || null;
//     const fYear = getCurrentFYear();
//     console.log(fYear);
//     const userId = user?.UserId || null;

//     const updateProgress = (value) => {
//         const clipped = Math.max(0, Math.min(100, value));
//         setProgressValue(clipped);
//         setBufferValue(Math.min(100, clipped + 10));
//     };

//     // Helper to check if a field has an error
//     const hasFieldError = (record, fieldKey) => {
//         if (!record._missingFields) return false;
//         const fieldMap = {
//             Name: "Name",
//             EmailId: "Email Id",
//             MobileNo: "Mobile No.",
//             DateOfBirth: "Date Of Birth",
//             Gender: "Gender",
//             Address: "Address",
//             Pincode: "Pincode",
//             City: "City",
//             State: "State",
//             Country: "Country",
//             ApplyFor: "Apply For",
//             DateOfApplication: "Date Of Application",
//             MaritalStatus: "Marital Status",
//             SpouseName: "Spouse Name",
//             SpouseContect: "Spouse Contact",
//             Source: "Source",
//             Qualification1: "Qualification1",
//             CollegeName1: "CollegeName1",
//             PassingYear1: "PassingYear1",
//             'Percentage/CGPA1': "Percentage/CGPA1",
//             Qualification2: "Qualification2",
//             CollegeName2: "CollegeName2",
//             PassingYear2: "PassingYear2",
//             'Percentage/CGPA2': "Percentage/CGPA2",
//             WorkExpriance: "Work Experience",
//             'YeasOfExp.': "Years Of Exp",
//             'MonthsOfExp.': "Months Of Exp",
//             CompanyName1: "CompanyName1",
//             JobTitle1: "JobTitle1",
//             Salary1: "Salary1",
//             FromDate1: "FromDate1",
//             ToDate1: "ToDate1",
//             ReasonOfLeaving1: "ReasonOfLeaving1",
//             CompanyName2: "CompanyName2",
//             JobTitle2: "JobTitle2",
//             Salary2: "Salary2",
//             FromDate2: "FromDate2",
//             ToDate2: "ToDate2",
//             ReasonOfLeaving2: "ReasonOfLeaving2",
//             CompanyName3: "CompanyName3",
//             JobTitle3: "JobTitle3",
//             Salary3: "Salary3",
//             FromDate3: "FromDate3",
//             ToDate3: "ToDate3",
//             RasonOfLeaving3: "ReasonOfLeaving3",
//             AlternateMobile: "Alternate Mobile"
//         };
//         const errorLabel = fieldMap[fieldKey];
//         return errorLabel ? record._missingFields.some(err => err.includes(errorLabel)) : false;
//     };

//     useEffect(() => {
//         const hasRedError = data.some(r => r._missingFields?.length > 0);
//         const handleBeforeUnload = (e) => {
//             if (hasRedError && data.length > 0) {
//                 e.preventDefault();
//                 e.returnValue = '';
//             }
//         };
//         window.addEventListener('beforeunload', handleBeforeUnload);
//         return () => window.removeEventListener('beforeunload', handleBeforeUnload);
//     }, [data]);

//     const handleFileChange = (e) => {
//         const selectedFile = e.target.files[0];
//         if (selectedFile) {
//             const validExtensions = [".xlsx", ".xls", ".csv"];
//             const fileExtension = selectedFile.name.slice(selectedFile.name.lastIndexOf(".")).toLowerCase();
//             if (!validExtensions.includes(fileExtension)) {
//                 setSnackbar({ open: true, message: "Only Excel (.xlsx, .xls) or CSV (.csv) files are allowed", severity: "error" });
//                 setFile(null);
//                 setData([]);
//                 setFilteredData([]);
//                 fileInputRef.current.value = "";
//                 return;
//             }

//             setFile(selectedFile);
//             fileInputRef.current.value = null;

//             setData([]);
//             setFilteredData([]);
//             setRowStatus({});
//             setFadeOutIds(new Set());
//             setShowBuffer(true);
//             setFilterMode('all');
//             updateProgress(3);

//             const clonedFile = new File([selectedFile], selectedFile.name, { type: selectedFile.type });
//             processFile(clonedFile);
//         }
//     };

//     const processFile = (file) => {
//         const reader = new FileReader();

//         reader.onprogress = (e) => {
//             if (e.lengthComputable) {
//                 const percentRead = Math.round((e.loaded / e.total) * 100);
//                 const mapped = Math.round(percentRead * 0.5);
//                 updateProgress(mapped);
//             }
//         };

//         reader.onload = (e) => {
//             try {
//                 const binaryData = e.target.result;
//                 const workbook = XLSX.read(binaryData, { type: "binary" });
//                 const sheetName = workbook.SheetNames[0];
//                 const sheet = workbook.Sheets[sheetName];
//                 const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

//                 const expectedHeaders = [
//                     "Name", "EmailId", "MobileNo", "DateOfBirth", "Gender", "Address", "Pincode",
//                     "City", "State", "Country", "ApplyFor", "ApplyForOther", "DateOfApplication", "NativePlace",
//                     "AlternateMobile", "MaritalStatus", "SpouseName", "SpouseContect", "BloodGroup",
//                     "FatherName", "FatherContact", "MotherName", "MotherContact", "Source", "ReferenceBy",
//                     "Qualification1", "CollegeName1", "PassingYear1", "Percentage/CGPA1",
//                     "Qualification2", "CollegeName2", "PassingYear2", "Percentage/CGPA2",
//                     "WorkExpriance", "YeasOfExp.", "MonthsOfExp.", "CompanyName1", "JobTitle1", "Salary1",
//                     "FromDate1", "ToDate1", "CurrentlyWorking1", "ReasonOfLeaving1",
//                     "CompanyName2", "JobTitle2", "Salary2", "FromDate2", "ToDate2", "CurrentlyWorking2", "ReasonOfLeaving2",
//                     "CompanyName3", "JobTitle3", "Salary3", "FromDate3", "ToDate3", "CurrentlyWorking3", "RasonOfLeaving3",
//                     "EnglishProficiency", "LanguegesKnown", "ExpectedCTC", "NoticePeriod", "PreferredJoiningDate"
//                 ];

//                 const headers = (jsonData[0] || []).map(h => (h ? String(h).trim() : "")).filter(h => h !== "");

//                 // More flexible validation - check if all expected headers exist in order
//                 const headersValid = headers.length === expectedHeaders.length &&
//                     expectedHeaders.every((header, index) => header === headers[index]);

//                 if (!headersValid) {
//                     const missing = expectedHeaders.filter((h, i) => headers[i] !== h);
//                     const errorDetails = missing.length > 0 ? `(Mismatch at column: ${missing[0]})` : "";
//                     setSnackbar({
//                         open: true,
//                         message: `Invalid file format. ${errorDetails}`,
//                         severity: "error"
//                     });
//                     setData([]);
//                     setFilteredData([]);
//                     updateProgress(0);
//                     setShowBuffer(false);
//                     return;
//                 }

//                 const requiredFields = [
//                     { key: 'Name', label: 'Name' },
//                     { key: 'EmailId', label: 'Email Id' },
//                     { key: 'MobileNo', label: 'Mobile No.' },
//                     { key: 'DateOfBirth', label: 'Date Of Birth' },
//                     { key: 'Gender', label: 'Gender' },
//                     { key: 'Address', label: 'Address' },
//                     { key: 'Pincode', label: 'Pincode' },
//                     { key: 'City', label: 'City' },
//                     { key: 'State', label: 'State' },
//                     { key: 'Country', label: 'Country' },
//                     { key: 'ApplyFor', label: 'Apply For' },
//                     { key: 'DateOfApplication', label: 'Date Of Application' },
//                     { key: 'MaritalStatus', label: 'Marital Status' },
//                     { key: 'Source', label: 'Source' },
//                     { key: 'Qualification1', label: 'Qualification1' },
//                     { key: 'CollegeName1', label: 'CollegeName1' },
//                     { key: 'PassingYear1', label: 'PassingYear1' },
//                     { key: 'Percentage/CGPA1', label: 'Percentage/CGPA1' },
//                     { key: 'WorkExpriance', label: 'Work Experience' }
//                 ];

//                 const formatExcelDate = (value) => {
//                     if (!value) return "";

//                     // If it's already a string in correct format, return it
//                     if (typeof value === 'string') {
//                         // Check if it's already DD/MM/YYYY
//                         if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) return value;
//                         // Check if it's YYYY-MM-DD
//                         if (/^\d{4}-\d{2}-\d{2}/.test(value)) {
//                             const date = new Date(value);
//                             const day = String(date.getDate()).padStart(2, '0');
//                             const month = String(date.getMonth() + 1).padStart(2, '0');
//                             const year = date.getFullYear();
//                             return `${day}/${month}/${year}`;
//                         }
//                         return value;
//                     }

//                     // If it's a Date object (from openpyxl)
//                     if (value instanceof Date) {
//                         const day = String(value.getDate()).padStart(2, '0');
//                         const month = String(value.getMonth() + 1).padStart(2, '0');
//                         const year = value.getFullYear();
//                         return `${day}/${month}/${year}`;
//                     }

//                     // If it's a number (Excel serial date)
//                     if (typeof value === 'number') {
//                         const excelEpoch = new Date(1900, 0, 1);
//                         const date = new Date(excelEpoch.getTime() + (value - 2) * 24 * 60 * 60 * 1000);
//                         const day = String(date.getDate()).padStart(2, '0');
//                         const month = String(date.getMonth() + 1).padStart(2, '0');
//                         const year = date.getFullYear();
//                         return `${day}/${month}/${year}`;
//                     }

//                     return "";
//                 };

//                 const parsedData = jsonData.slice(1).map((row) => {
//                     const record = {
//                         id: generateUniqueId(),
//                         Name: row[0] || "",
//                         EmailId: row[1] || "",
//                         MobileNo: row[2] || "",
//                         DateOfBirth: parseAndFormatDate(row[3]),
//                         Gender: row[4] || "",
//                         Address: row[5] || "",
//                         Pincode: row[6] || "",
//                         City: row[7] || "",
//                         State: row[8] || "",
//                         Country: row[9] || "",
//                         ApplyFor: row[10] || "",
//                         ApplyForOther: row[11] || "",
//                         DateOfApplication: parseAndFormatDate(row[12]),
//                         NativePlace: row[13] || "",
//                         AlternateMobile: row[14] || "",
//                         MaritalStatus: row[15] || "",
//                         SpouseName: row[16] || "",
//                         SpouseContect: row[17] || "",
//                         BloodGroup: row[18] || "",
//                         FatherName: row[19] || "",
//                         FatherContact: row[20] || "",
//                         MotherName: row[21] || "",
//                         MotherContact: row[22] || "",
//                         Source: row[23] || "",
//                         ReferenceBy: row[24] || "",
//                         Qualification1: row[25] || "",
//                         CollegeName1: row[26] || "",
//                         PassingYear1: row[27] || "",
//                         'Percentage/CGPA1': row[28] || "",
//                         Qualification2: row[29] || "",
//                         CollegeName2: row[30] || "",
//                         PassingYear2: row[31] || "",
//                         'Percentage/CGPA2': row[32] || "",
//                         WorkExpriance: row[33] || "",
//                         'YeasOfExp.': row[34] || "",
//                         'MonthsOfExp.': row[35] || "",
//                         CompanyName1: row[36] || "",
//                         JobTitle1: row[37] || "",
//                         Salary1: row[38] || "",
//                         FromDate1: parseAndFormatDate(row[39]),
//                         ToDate1: parseAndFormatDate(row[40]),
//                         CurrentlyWorking1: row[41] || "",
//                         ReasonOfLeaving1: row[42] || "",
//                         CompanyName2: row[43] || "",
//                         JobTitle2: row[44] || "",
//                         Salary2: row[45] || "",
//                         FromDate2: parseAndFormatDate(row[46]),
//                         ToDate2: parseAndFormatDate(row[47]),
//                         CurrentlyWorking2: row[48] || "",
//                         ReasonOfLeaving2: row[49] || "",
//                         CompanyName3: row[50] || "",
//                         JobTitle3: row[51] || "",
//                         Salary3: row[52] || "",
//                         FromDate3: parseAndFormatDate(row[53]),
//                         ToDate3: parseAndFormatDate(row[54]),
//                         CurrentlyWorking3: row[55] || "",
//                         RasonOfLeaving3: row[56] || "",
//                         EnglishProficiency: row[57] || "",
//                         LanguegesKnown: row[58] || "",
//                         ExpectedCTC: row[59] || "",
//                         NoticePeriod: row[60] || "",
//                         PreferredJoiningDate: parseAndFormatDate(row[61])
//                     };

//                     // ===== VALIDATION LOGIC =====
//                     const missing = requiredFields
//                         .filter(f => !record[f.key] || String(record[f.key]).trim() === '')
//                         .map(f => f.label);

//                     const validationErrors = [];

//                     // EMAIL VALIDATION
//                     if (record.EmailId && !isValidEmail(record.EmailId)) {
//                         validationErrors.push("Email Id must contain @ and .");
//                     }

//                     // MOBILE NO VALIDATION
//                     const mobileStr = record.MobileNo?.toString().trim();
//                     if (mobileStr && !/^\d{10}$/.test(mobileStr)) {
//                         validationErrors.push("Mobile No. must be 10 digits");
//                     }

//                     // ALTERNATE MOBILE VALIDATION
//                     const altMobileStr = record.AlternateMobile?.toString().trim();
//                     if (altMobileStr && !/^\d{10}$/.test(altMobileStr)) {
//                         validationErrors.push("Alternate Mobile must be 10 digits");
//                     }

//                     // FATHER & MOTHER CONTACT VALIDATION
//                     const fatherContactStr = record.FatherContact?.toString().trim();
//                     if (fatherContactStr && !/^\d{10}$/.test(fatherContactStr)) {
//                         validationErrors.push("Father Contact must be 10 digits");
//                     }

//                     const motherContactStr = record.MotherContact?.toString().trim();
//                     if (motherContactStr && !/^\d{10}$/.test(motherContactStr)) {
//                         validationErrors.push("Mother Contact must be 10 digits");
//                     }

//                     // DATE OF BIRTH VALIDATION
//                     if (record.DateOfBirth && !isValidDateFormat(record.DateOfBirth)) {
//                         validationErrors.push("Date Of Birth must be in DD-MM-YYYY format");
//                     }

//                     // GENDER VALIDATION
//                     if (record.Gender && !['Male', 'Female', 'Other'].includes(record.Gender.trim())) {
//                         validationErrors.push("Gender must be Male, Female, or Other");
//                     }

//                     // PINCODE VALIDATION
//                     const pincodeStr = record.Pincode?.toString().trim();
//                     if (pincodeStr && !/^\d{6}$/.test(pincodeStr)) {
//                         validationErrors.push("Pincode must be 6 digits");
//                     }

//                     // DATE OF APPLICATION VALIDATION
//                     if (record.DateOfApplication && !isValidDateFormat(record.DateOfApplication)) {
//                         validationErrors.push("Date Of Application must be in DD-MM-YYYY format");
//                     }

//                     if (record.MaritalStatus) {
//                         const maritalStatus = record.MaritalStatus.trim();

//                         // If MaritalStatus is 'Yes' or 'Married', require Spouse fields
//                         if (maritalStatus === 'Yes' || maritalStatus === 'Married') {
//                             if (isEmpty(record.SpouseName)) {
//                                 validationErrors.push("Spouse Name is required when Marital Status is Yes/Married");
//                             }
//                             if (isEmpty(record.SpouseContect)) {
//                                 validationErrors.push("Spouse Contact is required when Marital Status is Yes/Married");
//                             } else {
//                                 const spouseContactStr = record.SpouseContect?.toString().trim();
//                                 if (!/^\d{10}$/.test(spouseContactStr)) {
//                                     validationErrors.push("Spouse Contact must be 10 digits");
//                                 }
//                             }
//                         }
//                         // If MaritalStatus is 'No' or 'Single' or 'Divorced', Spouse fields are NOT required
//                     }

//                     const qual2Fields = ['Qualification2', 'CollegeName2', 'PassingYear2', 'Percentage/CGPA2'];
//                     if (hasAnyFieldData(record, qual2Fields)) {
//                         // Check each field individually (like WorkExperience logic)
//                         const qual2RequiredFields = ['Qualification2', 'CollegeName2', 'PassingYear2', 'Percentage/CGPA2'];
//                         qual2RequiredFields.forEach(field => {
//                             if (isEmpty(record[field])) {
//                                 validationErrors.push(`${field} is required for Qualification2`);
//                             }
//                         });

//                         // Also validate PassingYear2 format if it exists
//                         if (record.PassingYear2 && !isValidYear(record.PassingYear2)) {
//                             validationErrors.push("Passing Year2 must be a valid year (1900-current)");
//                         }
//                     }

//                     // WORK EXPERIENCE VALIDATION
//                     if (record.WorkExpriance) {
//                         const workExp = record.WorkExpriance.trim();

//                         if (workExp === 'Yes') {
//                             // Check required fields for Yes
//                             const exp1RequiredFields = ['YeasOfExp.', 'MonthsOfExp.', 'CompanyName1', 'JobTitle1', 'Salary1', 'FromDate1', 'ToDate1', 'ReasonOfLeaving1'];
//                             exp1RequiredFields.forEach(field => {
//                                 if (isEmpty(record[field])) {
//                                     const fieldLabel = field === 'YeasOfExp.' ? 'Years Of Exp' : field === 'MonthsOfExp.' ? 'Months Of Exp' : field;
//                                     validationErrors.push(`${fieldLabel} is required for Work Experience Yes`);
//                                 }
//                             });

//                             // Validate FromDate1 and ToDate1 format
//                             if (record.FromDate1 && !isValidDateFormat(record.FromDate1)) {
//                                 validationErrors.push("FromDate1 must be in DD-MM-YYYY format");
//                             }
//                             if (record.ToDate1 && !isValidDateFormat(record.ToDate1)) {
//                                 validationErrors.push("ToDate1 must be in DD-MM-YYYY format");
//                             }

//                             const company2Fields = ['CompanyName2', 'JobTitle2', 'Salary2', 'FromDate2', 'ToDate2', 'ReasonOfLeaving2'];
//                             if (hasAnyFieldData(record, company2Fields)) {
//                                 // Check each field individually (like WorkExperience logic)
//                                 const company2RequiredFields = ['CompanyName2', 'JobTitle2', 'Salary2', 'FromDate2', 'ToDate2', 'ReasonOfLeaving2'];
//                                 const company2FieldLabels = {
//                                     'CompanyName2': 'CompanyName2',
//                                     'JobTitle2': 'JobTitle2',
//                                     'Salary2': 'Salary2',
//                                     'FromDate2': 'FromDate2',
//                                     'ToDate2': 'ToDate2',
//                                     'ReasonOfLeaving2': 'ReasonOfLeaving2'
//                                 };
//                                 company2RequiredFields.forEach(field => {
//                                     if (isEmpty(record[field])) {
//                                         validationErrors.push(`${company2FieldLabels[field]} is required for Company2`);
//                                     }
//                                 });

//                                 // Also validate date formats if they exist
//                                 if (record.FromDate2 && !isValidDateFormat(record.FromDate2)) {
//                                     validationErrors.push("FromDate2 must be in DD-MM-YYYY format");
//                                 }
//                                 if (record.ToDate2 && !isValidDateFormat(record.ToDate2)) {
//                                     validationErrors.push("ToDate2 must be in DD-MM-YYYY format");
//                                 }
//                             }

//                             // COMPANY3 CONDITIONAL VALIDATION
//                             const company3Fields = ['CompanyName3', 'JobTitle3', 'Salary3', 'FromDate3', 'ToDate3', 'RasonOfLeaving3'];
//                             if (hasAnyFieldData(record, company3Fields)) {
//                                 // Check each field individually (like WorkExperience logic)
//                                 const company3RequiredFields = ['CompanyName3', 'JobTitle3', 'Salary3', 'FromDate3', 'ToDate3', 'RasonOfLeaving3'];
//                                 const company3FieldLabels = {
//                                     'CompanyName3': 'CompanyName3',
//                                     'JobTitle3': 'JobTitle3',
//                                     'Salary3': 'Salary3',
//                                     'FromDate3': 'FromDate3',
//                                     'ToDate3': 'ToDate3',
//                                     'RasonOfLeaving3': 'RasonOfLeaving3'
//                                 };
//                                 company3RequiredFields.forEach(field => {
//                                     if (isEmpty(record[field])) {
//                                         validationErrors.push(`${company3FieldLabels[field]} is required for Company3`);
//                                     }
//                                 });

//                                 // Also validate date formats if they exist
//                                 if (record.FromDate3 && !isValidDateFormat(record.FromDate3)) {
//                                     validationErrors.push("FromDate3 must be in DD-MM-YYYY format");
//                                 }
//                                 if (record.ToDate3 && !isValidDateFormat(record.ToDate3)) {
//                                     validationErrors.push("ToDate3 must be in DD-MM-YYYY format");
//                                 }
//                             }
//                         } else if (workExp !== 'No') {
//                             validationErrors.push("Work Experience must be Yes or No");
//                         }
//                     }

//                     // Validate PassingYear1
//                     if (record.PassingYear1 && !isValidYear(record.PassingYear1)) {
//                         validationErrors.push("Passing Year1 must be a valid year (1900-current)");
//                     }

//                     record._missingFields = [...missing, ...validationErrors];

//                     return record;
//                 }).filter(row =>
//                     row.Name || row.EmailId || row.MobileNo
//                 );

//                 setData(parsedData);
//                 setFilteredData(parsedData);
//                 setInsertedIds(new Set());
//                 setFadeOutIds(new Set());
//                 setRowStatus({});

//                 updateProgress(50);
//                 setSnackbar({ open: true, message: `Successfully parsed ${parsedData.length} records`, severity: "success" });

//                 updateProgress(100);
//                 setTimeout(() => {
//                     setShowBuffer(false);
//                     updateProgress(0);
//                 }, 800);
//             } catch (err) {
//                 console.error(err);
//                 setSnackbar({ open: true, message: "Error parsing file", severity: "error" });
//                 setData([]);
//                 setFilteredData([]);
//                 updateProgress(0);
//                 setShowBuffer(false);
//             }
//         };

//         reader.onerror = () => {
//             setSnackbar({ open: true, message: "Error reading file", severity: "error" });
//             setData([]);
//             setFilteredData([]);
//             updateProgress(0);
//             setShowBuffer(false);
//         };

//         reader.readAsBinaryString(file);
//     };

//     const convertDateFormat = (dateStr) => {
//         if (!dateStr) return null;

//         const str = String(dateStr).trim();

//         // If already in YYYY-MM-DD format, return as is
//         if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
//             return str;
//         }

//         // Convert DD-MM-YYYY or DD/MM/YYYY to YYYY-MM-DD
//         if (/^\d{2}[-\/]\d{2}[-\/]\d{4}$/.test(str)) {
//             const parts = str.split(/[-\/]/);
//             const day = parts[0];
//             const month = parts[1];
//             const year = parts[2];

//             // Validate date
//             const dateObj = new Date(year, month - 1, day);
//             if (isNaN(dateObj.getTime())) {
//                 return null;
//             }

//             return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
//         }

//         return null;
//     };
//     const handleUploadSubmit = async () => {
//         if (!data.length) {
//             setSnackbar({ open: true, message: "No data to upload", severity: "error" });
//             return;
//         }

//         const validRows = data.filter(r => !r._missingFields || r._missingFields.length === 0);
//         const errorRows = data.filter(r => r._missingFields?.length > 0);

//         if (validRows.length === 0) {
//             setSnackbar({ open: true, message: "All rows contain errors – nothing to insert", severity: "error" });
//             return;
//         }

//         if (!companyId || !userId) {
//             setSnackbar({ open: true, message: "Missing company/user data", severity: "error" });
//             return;
//         }

//         setUploading(true);
//         setShowBuffer(true);
//         updateProgress(0);

//         let insertedCount = 0;
//         let existsCount = 0;
//         let failedCount = 0;
//         const insertedRowIds = [];

//         try {
//             // Process each row ONE BY ONE
//             for (let i = 0; i < validRows.length; i++) {
//                 const row = validRows[i];

//                 // ===== BUILD EDUCATION ARRAY =====
//                 const education = [];

//                 // Education 1: Check if ANY field has data
//                 if (row.Qualification1 || row.CollegeName1 || row.PassingYear1 || row['Percentage/CGPA1']) {
//                     education.push({
//                         qualification: row.Qualification1 || null,
//                         collegeName: row.CollegeName1 || null,
//                         passingYear: row.PassingYear1 || null,
//                         percentage: row['Percentage/CGPA1'] ? Number(row['Percentage/CGPA1']) : null
//                     });
//                 }

//                 // Education 2: Check if ANY field has data
//                 if (row.Qualification2 || row.CollegeName2 || row.PassingYear2 || row['Percentage/CGPA2']) {
//                     education.push({
//                         qualification: row.Qualification2 || null,
//                         collegeName: row.CollegeName2 || null,
//                         passingYear: row.PassingYear2 || null,
//                         percentage: row['Percentage/CGPA2'] ? Number(row['Percentage/CGPA2']) : null
//                     });
//                 }

//                 // ===== BUILD EXPERIENCE DETAILS ARRAY =====
//                 const experienceDetails = [];

//                 // Company 1: Check if ANY field has data
//                 if (row.CompanyName1 || row.JobTitle1 || row.Salary1 || row.FromDate1 || row.ToDate1 || row.ReasonOfLeaving1) {
//                     experienceDetails.push({
//                         companyName: row.CompanyName1 || null,
//                         jobTitle: row.JobTitle1 || null,
//                         salaryPerMonth: row.Salary1 ? Number(row.Salary1) : null,
//                         reasonForLeaving: row.ReasonOfLeaving1 || null,
//                         fromDate: convertDateFormat(row.FromDate1) || null,
//                         toDate: convertDateFormat(row.ToDate1) || null,
//                         currentlyWorking: row.CurrentlyWorking1 ? 1 : 0
//                     });
//                 }

//                 // Company 2: Check if ANY field has data
//                 if (row.CompanyName2 || row.JobTitle2 || row.Salary2 || row.FromDate2 || row.ToDate2 || row.ReasonOfLeaving2) {
//                     experienceDetails.push({
//                         companyName: row.CompanyName2 || null,
//                         jobTitle: row.JobTitle2 || null,
//                         salaryPerMonth: row.Salary2 ? Number(row.Salary2) : null,
//                         reasonForLeaving: row.ReasonOfLeaving2 || null,
//                         fromDate: convertDateFormat(row.FromDate2) || null,
//                         toDate: convertDateFormat(row.ToDate2) || null,
//                         currentlyWorking: row.CurrentlyWorking2 ? 1 : 0
//                     });
//                 }

//                 // Company 3: Check if ANY field has data
//                 if (row.CompanyName3 || row.JobTitle3 || row.Salary3 || row.FromDate3 || row.ToDate3 || row.RasonOfLeaving3) {
//                     experienceDetails.push({
//                         companyName: row.CompanyName3 || null,
//                         jobTitle: row.JobTitle3 || null,
//                         salaryPerMonth: row.Salary3 ? Number(row.Salary3) : null,
//                         reasonForLeaving: row.RasonOfLeaving3 || null,
//                         fromDate: convertDateFormat(row.FromDate3) || null,
//                         toDate: convertDateFormat(row.ToDate3) || null,
//                         currentlyWorking: row.CurrentlyWorking3 ? 1 : 0
//                     });
//                 }

//                 // ===== CREATE PAYLOAD WITH NESTED STRUCTURE =====
//                 const payload = {
//                     // Meta Object
//                     meta: {
//                         GCompId: null,
//                         CompId: companyId,
//                         FYear: fYear,
//                         userId: userId,
//                         BranchId: null
//                     },

//                     // Personal Object
//                     personal: {
//                         CandidateName: row.Name,
//                         MobileNo: row.MobileNo?.toString(),
//                         EmailId: row.EmailId,
//                         DOB: convertDateFormat(row.DateOfBirth),
//                         Gender: row.Gender,
//                         Address: row.Address,
//                         city: row.City || "",
//                         state: row.State || "",
//                         country: row.Country || "",
//                         NativePlace: row.NativePlace || "",
//                         AppliedFor: row.ApplyFor,
//                         ApplyForOther: row.ApplyForOther || "",
//                         pinCode: row.Pincode ? Number(row.Pincode) : null,
//                         dateOfApplication: convertDateFormat(row.DateOfApplication),
//                         altMobileNo: row.AlternateMobile || "",
//                         maritalStatus: row.MaritalStatus,
//                         spouseName: row.SpouseName || "",
//                         spouseContact: row.SpouseContect || "",
//                         bloodGroup: row.BloodGroup || "",
//                         fatherName: row.FatherName || "",
//                         fatherContact: row.FatherContact || "",
//                         motherName: row.MotherName || "",
//                         motherContact: row.MotherContact || "",
//                         Source: row.Source,
//                         ReferenceBy: row.ReferenceBy || ""
//                     },

//                     // Education Array
//                     education: education,

//                     // Experience Object
//                     experience: {
//                         ExperienceYears: row['YeasOfExp.'] ? Number(row['YeasOfExp.']) : null,
//                         ExperienceMonths: row['MonthsOfExp.'] ? Number(row['MonthsOfExp.']) : null,
//                         experienceDetails: experienceDetails
//                     },

//                     // Preference Object
//                     preference: {
//                         salaryExpected: row.ExpectedCTC ? Number(row.ExpectedCTC) : null,
//                         joiningDate: convertDateFormat(row.PreferredJoiningDate),
//                         noticePeriod: row.NoticePeriod || "",
//                         englishProficiency: row.EnglishProficiency || "",
//                         languagesKnown: row.LanguegesKnown || ""
//                     }
//                 };

//                 console.log(`[${i + 1}/${validRows.length}] Uploading: ${row.Name}`);

//                 try {
//                     // ===== SEND ONE REQUEST AT A TIME =====
//                     const response = await axios.post(`${path}/candidate/insert`, payload, {
//                         validateStatus: (status) => [200, 201, 204, 304, 500].includes(status)
//                     });

//                     const status = response.status;
//                     let message = "";

//                     if (status === 201) {
//                         message = "Inserted";
//                         insertedCount++;
//                         insertedRowIds.push(row.id);
//                         console.log(`✅ [${i + 1}/${validRows.length}] ${row.Name} - Inserted successfully`);
//                     } else if (status === 204 || status === 304) {
//                         message = "Already Exists";
//                         existsCount++;
//                         console.log(`⚠️  [${i + 1}/${validRows.length}] ${row.Name} - Already exists`);
//                     } else {
//                         message = "Failed";
//                         failedCount++;
//                         console.error(`❌ [${i + 1}/${validRows.length}] ${row.Name} - Failed`, response.data);
//                     }

//                     // Update UI immediately after each response
//                     setRowStatus(prev => ({
//                         ...prev,
//                         [row.id]: { status, message }
//                     }));

//                 } catch (err) {
//                     console.error(`❌ [${i + 1}/${validRows.length}] ${row.Name} - Error:`, err.response?.data || err.message);
//                     const status = err.response?.status || 500;

//                     setRowStatus(prev => ({
//                         ...prev,
//                         [row.id]: { status, message: "Failed" }
//                     }));

//                     failedCount++;
//                 }

//                 // ===== UPDATE PROGRESS BAR =====
//                 // Calculate percentage: 0-100%
//                 const progressPercentage = Math.round(((i + 1) / validRows.length) * 100);
//                 updateProgress(progressPercentage);

//                 console.log(`Progress: ${progressPercentage}% (${i + 1}/${validRows.length})`);

//                 // Add a small delay between requests to avoid overwhelming the server
//                 // Remove this if you want requests to be sent even faster
//                 if (i < validRows.length - 1) {
//                     await new Promise(resolve => setTimeout(resolve, 100)); // 100ms delay between requests
//                 }
//             }

//             // ===== SHOW SUMMARY SNACKBAR =====
//             const parts = [];
//             if (insertedCount) parts.push(`✅ ${insertedCount} Inserted`);
//             if (existsCount) parts.push(`⚠️  ${existsCount} Already Exists`);
//             if (failedCount) parts.push(`❌ ${failedCount} Failed`);
//             if (errorRows.length) parts.push(`⏭️  ${errorRows.length} Skipped (errors)`);

//             setSnackbar({
//                 open: true,
//                 message: parts.join(" | "),
//                 severity: insertedCount > 0 ? "success" : "warning"
//             });

//             // ===== FADE OUT AND REMOVE INSERTED ROWS =====
//             setTimeout(() => {
//                 const sortedFadeIds = insertedRowIds
//                     .map(id => ({ id, name: data.find(r => r.id === id)?.Name || "" }))
//                     .sort((a, b) => (a.name || "").localeCompare(b.name || ""))
//                     .map(item => item.id);

//                 // Fade out each row one by one
//                 sortedFadeIds.forEach((id, index) => {
//                     setTimeout(() => {
//                         setFadeOutIds(prev => new Set(prev).add(id));
//                     }, index * 300); // 300ms delay between fade outs
//                 });

//                 // Remove faded rows from data after animation
//                 setTimeout(() => {
//                     setData(prev => prev.filter(r => !insertedRowIds.includes(r.id)));
//                     setInsertedIds(new Set());
//                     setFadeOutIds(new Set());
//                     setRowStatus({});
//                 }, sortedFadeIds.length * 300 + 600);
//             }, 1000); // Wait 1 second before starting fade out

//         } catch (error) {
//             console.error("Unexpected error:", error);
//             setSnackbar({ open: true, message: "Unexpected error occurred", severity: "error" });
//         } finally {
//             setUploading(false);
//             setShowBuffer(false);
//         }
//     };



//     const handleBackClick = () => { navigate("/main/CandidateDetails"); };

//     const sortedData = useMemo(() => {
//         const withError = data.filter(r => (r._missingFields?.length || 0) > 0);
//         const withoutError = data.filter(r => !r._missingFields || r._missingFields.length === 0);

//         const sortedWithoutError = [...withoutError].sort((a, b) => {
//             const nameA = (a.Name || "").trim().toLowerCase();
//             const nameB = (b.Name || "").trim().toLowerCase();
//             return nameA.localeCompare(nameB);
//         });

//         return [...withError, ...sortedWithoutError];
//     }, [data]);

//     const filteredDataFinal = useMemo(() => {
//         let result = sortedData;

//         if (filterMode === 'perfect') {
//             result = result.filter(r => !r._missingFields || r._missingFields.length === 0);
//         } else if (filterMode === 'error') {
//             result = result.filter(r => r._missingFields?.length > 0);
//         }

//         if (searchText.trim()) {
//             const lowerSearch = searchText.toLowerCase();
//             result = result.filter(row =>
//                 row.Name?.toLowerCase().includes(lowerSearch) ||
//                 row.MobileNo?.toLowerCase().includes(lowerSearch) ||
//                 row.EmailId?.toLowerCase().includes(lowerSearch)
//             );
//         }

//         return result;
//     }, [sortedData, filterMode, searchText]);

//     useMemo(() => {
//         setFilteredData(filteredDataFinal);
//     }, [filteredDataFinal]);

//     const errorCount = useMemo(() => data.filter(r => r._missingFields?.length > 0).length, [data]);
//     const perfectCount = useMemo(() => data.length - errorCount, [data]);
//     const validRowsCount = useMemo(() => data.filter(r => !r._missingFields || r._missingFields.length === 0).length, [data]);

//     const fieldGroups = [
//         {
//             title: "Personal Info",
//             icon: <PersonIcon fontSize="small" />,
//             fields: [
//                 { label: "Name", key: "Name" },
//                 { label: "Email Id", key: "EmailId" },
//                 { label: "Mobile No.", key: "MobileNo" },
//                 { label: "Alternate Mobile", key: "AlternateMobile" },
//                 { label: "Date Of Birth", key: "DateOfBirth" },
//                 { label: "Gender", key: "Gender" },
//             ]
//         },
//         {
//             title: "Address & Location",
//             icon: <LocationOnIcon fontSize="small" />,
//             fields: [
//                 { label: "Address", key: "Address" },
//                 { label: "City", key: "City" },
//                 { label: "State", key: "State" },
//                 { label: "Pincode", key: "Pincode" },
//                 { label: "Country", key: "Country" },
//                 { label: "Native Place", key: "NativePlace" },
//             ]
//         },
//         {
//             title: "Application & Family",
//             icon: <EmailIcon fontSize="small" />,
//             fields: [
//                 { label: "Apply For", key: "ApplyFor" },
//                 { label: "Apply For Other", key: "ApplyForOther" },
//                 { label: "Date Of Application", key: "DateOfApplication" },
//                 { label: "Marital Status", key: "MaritalStatus" },
//                 { label: "Spouse Name", key: "SpouseName" },
//                 { label: "Spouse Contact", key: "SpouseContect" },
//                 { label: "Blood Group", key: "BloodGroup" },
//                 { label: "Father Name", key: "FatherName" },
//                 { label: "Father Contact", key: "FatherContact" },
//                 { label: "Mother Name", key: "MotherName" },
//                 { label: "Mother Contact", key: "MotherContact" },
//             ]
//         },
//         {
//             title: "Education",
//             icon: <SchoolIcon fontSize="small" />,
//             fields: [
//                 { label: "Qualification1", key: "Qualification1" },
//                 { label: "CollegeName1", key: "CollegeName1" },
//                 { label: "PassingYear1", key: "PassingYear1" },
//                 { label: "Percentage/CGPA1", key: "Percentage/CGPA1" },
//                 { label: "Qualification2", key: "Qualification2" },
//                 { label: "CollegeName2", key: "CollegeName2" },
//                 { label: "PassingYear2", key: "PassingYear2" },
//                 { label: "Percentage/CGPA2", key: "Percentage/CGPA2" },
//             ]
//         },
//         {
//             title: "Work Experience",
//             icon: <WorkIcon fontSize="small" />,
//             fields: [
//                 { label: "Work Experience", key: "WorkExpriance" },
//                 { label: "Years Of Exp", key: "YeasOfExp." },
//                 { label: "Months Of Exp", key: "MonthsOfExp." },
//                 { label: "CompanyName1", key: "CompanyName1" },
//                 { label: "JobTitle1", key: "JobTitle1" },
//                 { label: "Salary1", key: "Salary1" },
//                 { label: "FromDate1", key: "FromDate1" },
//                 { label: "ToDate1", key: "ToDate1" },
//                 { label: "Currently Working1", key: "CurrentlyWorking1" },
//                 { label: "ReasonOfLeaving1", key: "ReasonOfLeaving1" },
//                 { label: "CompanyName2", key: "CompanyName2" },
//                 { label: "JobTitle2", key: "JobTitle2" },
//                 { label: "Salary2", key: "Salary2" },
//                 { label: "FromDate2", key: "FromDate2" },
//                 { label: "ToDate2", key: "ToDate2" },
//                 { label: "Currently Working2", key: "CurrentlyWorking2" },
//                 { label: "ReasonOfLeaving2", key: "ReasonOfLeaving2" },
//                 { label: "CompanyName3", key: "CompanyName3" },
//                 { label: "JobTitle3", key: "JobTitle3" },
//                 { label: "Salary3", key: "Salary3" },
//                 { label: "FromDate3", key: "FromDate3" },
//                 { label: "ToDate3", key: "ToDate3" },
//                 { label: "Currently Working3", key: "CurrentlyWorking3" },
//                 { label: "ReasonOfLeaving3", key: "RasonOfLeaving3" },
//             ]
//         },
//         {
//             title: "Additional Info",
//             icon: <PhoneIcon fontSize="small" />,
//             fields: [
//                 { label: "Source", key: "Source" },
//                 { label: "Reference By", key: "ReferenceBy" },
//                 { label: "English Proficiency", key: "EnglishProficiency" },
//                 { label: "Languages Known", key: "LanguegesKnown" },
//                 { label: "Expected CTC", key: "ExpectedCTC" },
//                 { label: "Notice Period", key: "NoticePeriod" },
//                 { label: "Preferred Joining Date", key: "PreferredJoiningDate" },
//             ]
//         }
//     ];

//     return (
//         <Container sx={{ pt: 3, maxWidth: "1400px !important" }}>
//             <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
//                 <Typography variant="h5" sx={{ fontWeight: 600, color: "#1976D2" }}> Insert Candidate Data </Typography>
//                 <Tooltip title="Back to Options" placement="left">
//                     <IconButton onClick={handleBackClick} sx={{ bgcolor: "#1877F2", color: "white", width: 36, height: 36, "&:hover": { bgcolor: "#145db5" }, borderRadius: 2 }} > <ArrowBackIcon /> </IconButton>
//                 </Tooltip>
//             </Box>

//             <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
//                 <Paper sx={{ p: 3, borderRadius: 3, bgcolor: "background.paper", boxShadow: 3, position: "relative" }}>
//                     <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: "center", justifyContent: "space-between" }}>
//                         <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: "center", flex: 1 }}>
//                             <input type="file" accept=".xlsx,.xls,.csv" onChange={handleFileChange} ref={fileInputRef} style={{ display: "none" }} id="file-upload" />
//                             <Button
//                                 variant="contained"
//                                 onClick={() => {
//                                     const hasError = data.some(r => r._missingFields?.length > 0);
//                                     if (data.length > 0 && hasError && !window.confirm("There are rows with errors. Are you sure you want to choose a new file?")) {
//                                         return;
//                                     }
//                                     fileInputRef.current.click();
//                                 }}
//                                 sx={{ height: 40, bgcolor: "#1877F2", "&:hover": { bgcolor: "#145db5" }, borderRadius: 2, textTransform: "none", fontWeight: "medium", px: 2 }}
//                             >
//                                 Choose File
//                             </Button>
//                             <Typography variant="body2" sx={{ color: "#555", wordBreak: "break-word" }}>
//                                 {file ? file.name : "No file selected (Excel or CSV only)"}
//                             </Typography>
//                         </Box>

//                         {(file || data.length > 0) && (
//                             <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                                 <Button variant="contained" onClick={handleUploadSubmit} disabled={uploading || !data.length || validRowsCount === 0} sx={{ height: 40, bgcolor: "#1976D2", "&:hover": { bgcolor: "#115293" }, borderRadius: 2, textTransform: "none", fontWeight: "medium", px: 2, "&.Mui-disabled": { bgcolor: "#bdbdbd", color: "#666" } }} > {uploading ? <CircularProgress size={24} color="inherit" /> : <><InsertDriveFileIcon sx={{ mr: 1 }} /> Insert</>} </Button>
//                                 <Box sx={{ width: 240 }}>
//                                     {showBuffer ? (
//                                         <>
//                                             <LinearProgress variant="buffer" value={progressValue} valueBuffer={bufferValue} sx={{ height: 8, borderRadius: 4 }} />
//                                             <Typography variant="caption" sx={{ mt: 0.5, textAlign: "center" }}> {uploading ? `Uploading: ${Math.round(progressValue)}%` : `${progressValue}%`} </Typography>
//                                         </>
//                                     ) : null}
//                                 </Box>
//                             </Box>
//                         )}

//                         {data.length > 0 && (
//                             <Box sx={{ display: "flex", gap: 1, ml: "auto", pl: 2 }}>
//                                 <Chip icon={<CheckCircleIcon sx={{ fontSize: 18, color: filterMode === 'perfect' ? '#1b5e20' : '#4caf50' }} />} label={perfectCount} onClick={() => setFilterMode(prev => prev === 'perfect' ? 'all' : 'perfect')} sx={{ bgcolor: filterMode === 'perfect' ? '#e8f5e9' : '#f1f8e9', color: filterMode === 'perfect' ? '#1b5e20' : '#2e7d32', fontWeight: 600, border: filterMode === 'perfect' ? '2px solid #4caf50' : '1px solid #a5d6a7', cursor: 'pointer', '&:hover': { bgcolor: '#dcedc8' } }} size="small" />
//                                 <Chip icon={<ErrorIcon sx={{ fontSize: 18, color: filterMode === 'error' ? '#c62828' : '#f44336' }} />} label={errorCount} onClick={() => setFilterMode(prev => prev === 'error' ? 'all' : 'error')} sx={{ bgcolor: filterMode === 'error' ? '#ffebee' : '#fff3e0', color: filterMode === 'error' ? '#c62828' : '#d32f2f', fontWeight: 600, border: filterMode === 'error' ? '2px solid #f44336' : '1px solid #ff8a65', cursor: 'pointer', '&:hover': { bgcolor: '#ffcdd2' } }} size="small" />
//                             </Box>
//                         )}
//                     </Box>
//                 </Paper>

//                 {data.length > 0 && (
//                     <GlassParentCard>
//                         {/* <Box p={2} pb={1}>
//                             <TextField fullWidth size="small" placeholder="Search by Name, Mobile No., or Email Id..." value={searchText} onChange={(e) => setSearchText(e.target.value)}
//                                 InputProps={{
//                                     startAdornment: (
//                                         <InputAdornment position="start">
//                                             <SearchIcon />
//                                         </InputAdornment>
//                                     ),
//                                 }}
//                                 sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: "background.paper", } }}
//                             />
//                         </Box> */}

//                         <Box flex={1} overflow="auto" p={2} pt={5}
//                             sx={{
//                                 maxHeight: "calc(78vh - 80px)",
//                                 '&::-webkit-scrollbar': { width: '8px' },
//                                 '&::-webkit-scrollbar-thumb': { background: '#888', borderRadius: '4px' },
//                                 '&::-webkit-scrollbar-thumb:hover': { background: '#555' }
//                             }}
//                         >
//                             <Stack spacing={2.5}>
//                                 {filteredData.length === 0 ? (
//                                     <Paper sx={{ p: 4, textAlign: "center", borderRadius: 3, bgcolor: "background.paper" }}>
//                                         <Typography variant="h6" color="text.secondary"> {searchText || filterMode !== 'all' ? "No records match your filter" : "No data loaded"} </Typography>
//                                     </Paper>
//                                 ) : (
//                                     filteredData.map((r, idx) => {
//                                         const missing = r._missingFields || [];
//                                         const isError = missing.length > 0;
//                                         const expanded = expandedCards[r.id];
//                                         const statusInfo = rowStatus[r.id];
//                                         const isFading = fadeOutIds.has(r.id);

//                                         let cardBg = "background.paper";
//                                         let borderColor = "divider";
//                                         let statusChip = null;

//                                         if (statusInfo) {
//                                             if (statusInfo.status === 201) {
//                                                 cardBg = "#e8f5e9";
//                                                 borderColor = "#4caf50";
//                                                 statusChip = { color: "#1b5e20", bg: "#4caf50", icon: <CheckCircleOutlineIcon sx={{ fontSize: 14 }} />, label: "Inserted" };
//                                             } else if ([204, 304].includes(statusInfo.status)) {
//                                                 cardBg = "#fff8e1";
//                                                 borderColor = "#ffb300";
//                                                 statusChip = { color: "#ff8f00", bg: "#ffb300", icon: <WarningIcon sx={{ fontSize: 14 }} />, label: "Already Exists" };
//                                             } else {
//                                                 cardBg = "#ffebee";
//                                                 borderColor = "#d32f2f";
//                                                 statusChip = { color: "#c62828", bg: "#d32f2f", icon: <ErrorIcon sx={{ fontSize: 14 }} />, label: "Failed" };
//                                             }
//                                         } else if (isError) {
//                                             cardBg = "#ffebee";
//                                             borderColor = "#d32f2f";
//                                         }

//                                         return (
//                                             <Card key={r.id} elevation={isError ? 6 : 3} sx={{ borderRadius: 3, bgcolor: cardBg, border: `2px solid ${borderColor}`, position: "relative", overflow: "visible", transition: "all 0.4s ease", opacity: isFading ? 0 : 1, transform: isFading ? "translateY(-20px)" : "none", height: isFading ? 0 : "auto", marginBottom: isFading ? "-10px" : 2.5, padding: isFading ? 0 : "16px", "&:hover": { boxShadow: isError ? 6 : 4 } }} >
//                                                 {statusChip && !isFading && (
//                                                     <Box sx={{ position: "absolute", bottom: 8, right: 12, bgcolor: statusChip.bg, color: "white", px: 1.5, py: 0.5, borderRadius: 2, fontSize: "0.75rem", fontWeight: 600, display: "flex", alignItems: "center", gap: 0.5, zIndex: 1 }} >
//                                                         {statusChip.icon}
//                                                         {statusChip.label}
//                                                     </Box>
//                                                 )}
//                                                 <CardContent sx={{ pt: 3, pb: statusChip ? 5 : 2 }}>
//                                                     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 4 }}>
//                                                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5, flex: 1 }}>
//                                                             <Box sx={{ bgcolor: statusInfo?.status === 201 ? "#4caf50" : (isError ? "#ef5350" : "#1976d2"), color: "white", width: 40, height: 40, borderRadius: 2, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "bold", flexShrink: 0 }} > {r.Name?.[0] || "?"} </Box>
//                                                             <Box sx={{ minWidth: 0 }}>
//                                                                 <Typography variant="h6" fontWeight={600} noWrap> {r.Name || "Unnamed"} </Typography>
//                                                                 <Typography variant="body2" color="text.secondary" noWrap> {r.ApplyFor || "—"} | {r.MobileNo || "—"} </Typography>
//                                                             </Box>
//                                                         </Box>

//                                                         <Box sx={{ display: 'flex', gap: 5, alignItems: 'flex-start', flexWrap: 'nowrap' }}>
//                                                             {[
//                                                                 { label: "Gender:", value: r.Gender || "—", key: "Gender" },
//                                                                 { label: "Email:", value: r.EmailId || "—", key: "EmailId" },
//                                                                 { label: "DOB:", value: r.DateOfBirth || "—", key: "DateOfBirth" },
//                                                                 { label: "Location:", value: `${r.City || ""}, ${r.State || ""}`.trim() || "—", key: "City" }
//                                                             ].map((item, i) => {
//                                                                 const hasErr = hasFieldError(r, item.key);
//                                                                 return (
//                                                                     <Box key={i} sx={{ bgcolor: hasErr ? '#ffebee' : 'transparent', borderRadius: 1, p: hasErr ? 0.5 : 0, transition: 'background 0.2s', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', minWidth: 160, flex: 1 }} >
//                                                                         <Typography variant="caption" sx={{ fontWeight: 600, color: hasErr ? '#d32f2f' : 'text.secondary', lineHeight: 1.3, whiteSpace: 'nowrap' }} > {item.label} </Typography>
//                                                                         <Typography variant="body2" fontWeight={500} noWrap sx={{ mt: 0.3, wordBreak: 'break-word', maxWidth: '100%' }} > {item.value} </Typography>
//                                                                     </Box>
//                                                                 );
//                                                             })}
//                                                         </Box>

//                                                         <IconButton size="small" onClick={() => toggleExpand(r.id)} sx={{ alignSelf: 'flex-start' }}>
//                                                             {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
//                                                         </IconButton>
//                                                     </Box>

//                                                     <Collapse in={expanded} timeout="auto" unmountOnExit>
//                                                         <Divider sx={{ my: 1.5 }} />
//                                                         <Box mt={2}>
//                                                             {fieldGroups.map((group, gIdx) => (
//                                                                 <Box key={gIdx} mb={2}>
//                                                                     <Typography variant="subtitle2" color="primary" gutterBottom sx={{ display: "flex", alignItems: "center", gap: 0.5 }}> {group.icon} {group.title} </Typography>
//                                                                     <Grid container spacing={1}>
//                                                                         {group.fields.map((f, fIdx) => (
//                                                                             <Grid item xs={6} key={fIdx}>
//                                                                                 <Box>
//                                                                                     <Typography variant="caption" sx={{ color: hasFieldError(r, f.key) ? '#d32f2f' : 'text.secondary', fontWeight: hasFieldError(r, f.key) ? 600 : 400 }} > {f.label} </Typography>
//                                                                                     <Typography variant="body2" fontWeight={500}> {r[f.key] || "—"} </Typography>
//                                                                                 </Box>
//                                                                             </Grid>
//                                                                         ))}
//                                                                     </Grid>
//                                                                 </Box>
//                                                             ))}
//                                                         </Box>
//                                                     </Collapse>
//                                                 </CardContent>
//                                             </Card>
//                                         );
//                                     })
//                                 )}
//                             </Stack>
//                         </Box>
//                     </GlassParentCard>
//                 )}
//             </Box>

//             <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={() => setSnackbar({ ...snackbar, open: false })} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
//                 <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: "100%" }}>
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </Container>
//     );
// };

// export default InsertCandidate;







import { colors as themeColors } from '../utils/theme';
import { colors, gradients } from '../utils/theme';
import React, { useState, useRef, useMemo, useEffect } from "react";
import {
    Box, Button, Container, Typography, Snackbar, Alert, CircularProgress, LinearProgress,
    Card, CardContent, Grid, TextField, InputAdornment, Paper, Divider, Stack, IconButton, Collapse, alpha, Chip, Tooltip, useMediaQuery, useTheme
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import * as XLSX from "xlsx";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import SearchIcon from '@mui/icons-material/Search';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import WarningIcon from '@mui/icons-material/Warning';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import SchoolIcon from '@mui/icons-material/School';
import WorkIcon from '@mui/icons-material/Work';
import { useAuth } from '../context/AuthContext';
import { getCurrentFYear } from '../utils/financialYear';

// Simple UUID-like ID generator for unique row IDs
const generateUniqueId = () => {
    return `row-${Math.random().toString(36).substr(2, 9)}-${Date.now().toString(36)}`;
};

// Modern Glass Card with enhanced styling
const GlassParentCard = ({ children }) => (
    <Paper
        elevation={0}
        sx={{
            borderRadius: { xs: 2, sm: 3, md: 4 },
            background: (theme) => `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 0.95)} 0%, ${alpha(theme.palette.background.paper, 0.85)} 100%)`,
            backdropFilter: "blur(20px)",
            WebKitBackdropFilter: "blur(20px)",
            border: `1px solid ${(theme) => alpha(theme.palette.primary.main, 0.1)}`,
            [`& .MuiPaper-root`]: { borderRadius: { xs: 2, sm: 3 } },
            boxShadow: "0 20px 60px rgba(25, 118, 210, 0.08), 0 0 1px rgba(25, 118, 210, 0.1)",
            position: "relative",
            overflow: "hidden",
            maxHeight: { xs: "calc(100vh - 300px)", sm: "calc(100vh - 250px)", md: "78vh" },
            display: "flex",
            flexDirection: "column",
            "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: 1,
                background: `linear-gradient(90deg, transparent, rgba(25, 118, 210, 0.3), transparent)`,
            },
            "&::after": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                width: 4,
                height: "100%",
                background: `linear-gradient(180deg, ${colors.primary.main}, ${colors.primary.main}, transparent)`,
                borderRadius: "0 8px 8px 0",
            }
        }}
    >
        {children}
    </Paper>
);

// Enhanced File Upload Zone
const FileUploadZone = ({ fileInputRef, file, handleFileChange, data }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [isDragOver, setIsDragOver] = useState(false);

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragOver(true);
    };

    const handleDragLeave = () => {
        setIsDragOver(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragOver(false);
        const droppedFiles = e.dataTransfer.files;
        if (droppedFiles.length > 0) {
            fileInputRef.current.files = droppedFiles;
            const event = new Event('change', { bubbles: true });
            Object.defineProperty(event, 'target', { value: fileInputRef.current, enumerable: true });
            handleFileChange(event);
        }
    };

    return (
        <Box
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            sx={{
                position: "relative",
                borderRadius: { xs: 2, sm: 3 },
                border: `2px dashed ${isDragOver ? colors.primary.main : alpha(colors.primary.main, 0.3)}`,
                p: { xs: 2, sm: 3 },
                textAlign: "center",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                background: isDragOver ? alpha(colors.primary.main, 0.05) : alpha(colors.primary.main, 0.02),
                cursor: "pointer",
                "&:hover": {
                    borderColor: colors.primary.main,
                    bgcolor: alpha(colors.primary.main, 0.04),
                },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: { xs: 120, sm: 140 },
                gap: 2,
            }}
        >
            <input type="file" accept=".xlsx,.xls,.csv" onChange={handleFileChange} ref={fileInputRef} style={{ display: "none" }} id="file-upload" />

            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
                <CloudUploadIcon sx={{ fontSize: { xs: 40, sm: 50 }, color: colors.primary.main, opacity: 0.7 }} />
                <Box>
                    <Typography
                        variant="body1"
                        sx={{
                            fontWeight: 600,
                            color: colors.primary.main,
                            fontSize: { xs: "0.95rem", sm: "1.1rem" },
                            mb: 0.5
                        }}
                    >
                        {file ? `Selected: ${file.name}` : "Drop your file here or click to browse"}
                    </Typography>
                    <Typography
                        variant="caption"
                        sx={{
                            color: "text.secondary",
                            fontSize: { xs: "0.75rem", sm: "0.875rem" }
                        }}
                    >
                        Excel (.xlsx, .xls) or CSV files only
                    </Typography>
                </Box>
            </Box>

            <Button
                variant="contained"
                onClick={(e) => {
                    e.stopPropagation();
                    const hasError = data.some(r => r._missingFields?.length > 0);
                    if (data.length > 0 && hasError && !window.confirm("There are rows with errors. Are you sure you want to choose a new file?")) {
                        return;
                    }
                    fileInputRef.current.click();
                }}
                sx={{
                    height: { xs: 36, sm: 40 },
                    bgcolor: colors.primary.main,
                    "&:hover": { bgcolor: colors.primary.dark },
                    borderRadius: 1.5,
                    textTransform: "none",
                    fontWeight: 600,
                    px: { xs: 2, sm: 2.5 },
                    whiteSpace: "nowrap",
                    fontSize: { xs: "0.85rem", sm: "0.95rem" },
                    boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                        bgcolor: colors.primary.dark,
                        boxShadow: "0 6px 16px rgba(25, 118, 210, 0.4)",
                        transform: "translateY(-2px)"
                    }
                }}
            >
                Browse
            </Button>
        </Box>
    );
};

const parseAndFormatDate = (value) => {
    if (!value) return "";

    let dateObj = null;
    let dateString = String(value).trim();

    // Handle Date Objects (from Excel)
    if (value instanceof Date) {
        dateObj = value;
    }
    // Handle Excel Serial Numbers (e.g., 38141)
    else if (typeof value === 'number' && value > 100 && value < 50000) {
        const excelEpoch = new Date(1900, 0, 1);
        dateObj = new Date(excelEpoch.getTime() + (value - 2) * 24 * 60 * 60 * 1000);
    }
    // Handle String Formats
    else if (typeof dateString === 'string') {
        dateString = dateString.trim();

        const patterns = [
            {
                regex: /^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/,
                dayIndex: 1,
                monthIndex: 2,
                yearIndex: 3
            },
            {
                regex: /^(\d{4})[\/\-](\d{1,2})[\/\-](\d{1,2})$/,
                dayIndex: 3,
                monthIndex: 2,
                yearIndex: 1
            },
        ];

        for (const pattern of patterns) {
            const match = dateString.match(pattern.regex);

            if (match) {
                let day = parseInt(match[pattern.dayIndex], 10);
                let month = parseInt(match[pattern.monthIndex], 10);
                const year = parseInt(match[pattern.yearIndex], 10);

                if (month < 1 || month > 12) {
                    continue;
                }

                const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

                if (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)) {
                    daysInMonth[1] = 29;
                }

                if (day < 1 || day > daysInMonth[month - 1]) {
                    continue;
                }

                dateObj = new Date(year, month - 1, day);
                break;
            }
        }

        if (!dateObj) {
            const parsed = new Date(dateString);
            if (!isNaN(parsed.getTime())) {
                dateObj = parsed;
            }
        }
    }

    if (dateObj && !isNaN(dateObj.getTime())) {
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    }

    return dateString;
};

const isValidDateFormat = (dateStr) => {
    if (!dateStr) return false;

    const regex = /^(\d{2})-(\d{2})-(\d{4})$/;
    const match = dateStr.match(regex);

    if (!match) return false;

    const day = parseInt(match[1], 10);
    const month = parseInt(match[2], 10);
    const year = parseInt(match[3], 10);

    if (month < 1 || month > 12) return false;
    if (day < 1 || day > 31) return false;
    if (year < 1900 || year > 2100) return false;

    const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)) {
        daysInMonth[1] = 29;
    }

    if (day > daysInMonth[month - 1]) return false;

    return true;
};

const isValidEmail = (email) => {
    if (!email) return false;
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

const isValidYear = (year) => {
    if (!year) return false;
    const numYear = Number(year);
    const currentYear = new Date().getFullYear();
    return /^\d{4}$/.test(year) && numYear >= 1900 && numYear <= currentYear;
};

const hasAnyFieldData = (record, fieldKeys) => {
    return fieldKeys.some(key => record[key] && String(record[key]).trim() !== '');
};

const isEmpty = (value) => !value || String(value).trim() === '';

const InsertCandidate = ({ connectionString }) => {
    const { user, selectedCompany, loading } = useAuth();
    const path = connectionString;
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));
    const fileInputRef = useRef(null);
    const [file, setFile] = useState(null);
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [progressValue, setProgressValue] = useState(0);
    const [bufferValue, setBufferValue] = useState(0);
    const [showBuffer, setShowBuffer] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
    const [searchText, setSearchText] = useState("");
    const [expandedCards, setExpandedCards] = useState({});
    const [filterMode, setFilterMode] = useState('all');
    const [insertedIds, setInsertedIds] = useState(new Set());
    const [fadeOutIds, setFadeOutIds] = useState(new Set());
    const [rowStatus, setRowStatus] = useState({});

    const toggleExpand = (id) => setExpandedCards(prev => ({ ...prev, [id]: !prev[id] }));

    console.log("InsertCandidate props:", { user, selectedCompany, connectionString });

    const companyId = selectedCompany?.CompId || null;
    const fYear = getCurrentFYear();
    console.log(fYear);
    const userId = user?.UserId || null;

    const updateProgress = (value) => {
        const clipped = Math.max(0, Math.min(100, value));
        setProgressValue(clipped);
        setBufferValue(Math.min(100, clipped + 10));
    };

    const hasFieldError = (record, fieldKey) => {
        if (!record._missingFields) return false;
        const fieldMap = {
            Name: "Name",
            EmailId: "Email Id",
            MobileNo: "Mobile No.",
            DateOfBirth: "Date Of Birth",
            Gender: "Gender",
            Address: "Address",
            Pincode: "Pincode",
            City: "City",
            State: "State",
            Country: "Country",
            ApplyFor: "Apply For",
            DateOfApplication: "Date Of Application",
            MaritalStatus: "Marital Status",
            SpouseName: "Spouse Name",
            SpouseContect: "Spouse Contact",
            Source: "Source",
            Qualification1: "Qualification1",
            CollegeName1: "CollegeName1",
            PassingYear1: "PassingYear1",
            'Percentage/CGPA1': "Percentage/CGPA1",
            Qualification2: "Qualification2",
            CollegeName2: "CollegeName2",
            PassingYear2: "PassingYear2",
            'Percentage/CGPA2': "Percentage/CGPA2",
            WorkExpriance: "Work Experience",
            'YeasOfExp.': "Years Of Exp",
            'MonthsOfExp.': "Months Of Exp",
            CompanyName1: "CompanyName1",
            JobTitle1: "JobTitle1",
            Salary1: "Salary1",
            FromDate1: "FromDate1",
            ToDate1: "ToDate1",
            ReasonOfLeaving1: "ReasonOfLeaving1",
            CompanyName2: "CompanyName2",
            JobTitle2: "JobTitle2",
            Salary2: "Salary2",
            FromDate2: "FromDate2",
            ToDate2: "ToDate2",
            ReasonOfLeaving2: "ReasonOfLeaving2",
            CompanyName3: "CompanyName3",
            JobTitle3: "JobTitle3",
            Salary3: "Salary3",
            FromDate3: "FromDate3",
            ToDate3: "ToDate3",
            RasonOfLeaving3: "ReasonOfLeaving3",
            AlternateMobile: "Alternate Mobile"
        };
        const errorLabel = fieldMap[fieldKey];
        return errorLabel ? record._missingFields.some(err => err.includes(errorLabel)) : false;
    };

    useEffect(() => {
        const hasRedError = data.some(r => r._missingFields?.length > 0);
        const handleBeforeUnload = (e) => {
            if (hasRedError && data.length > 0) {
                e.preventDefault();
                e.returnValue = '';
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [data]);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            const validExtensions = [".xlsx", ".xls", ".csv"];
            const fileExtension = selectedFile.name.slice(selectedFile.name.lastIndexOf(".")).toLowerCase();
            if (!validExtensions.includes(fileExtension)) {
                setSnackbar({ open: true, message: "Only Excel (.xlsx, .xls) or CSV (.csv) files are allowed", severity: "error" });
                setFile(null);
                setData([]);
                setFilteredData([]);
                fileInputRef.current.value = "";
                return;
            }

            setFile(selectedFile);
            fileInputRef.current.value = null;

            setData([]);
            setFilteredData([]);
            setRowStatus({});
            setFadeOutIds(new Set());
            setShowBuffer(true);
            setFilterMode('all');
            updateProgress(3);

            const clonedFile = new File([selectedFile], selectedFile.name, { type: selectedFile.type });
            processFile(clonedFile);
        }
    };

    const processFile = (file) => {
        const reader = new FileReader();

        reader.onprogress = (e) => {
            if (e.lengthComputable) {
                const percentRead = Math.round((e.loaded / e.total) * 100);
                const mapped = Math.round(percentRead * 0.5);
                updateProgress(mapped);
            }
        };

        reader.onload = (e) => {
            try {
                const binaryData = e.target.result;
                const workbook = XLSX.read(binaryData, { type: "binary" });
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

                const expectedHeaders = [
                    "Name", "EmailId", "MobileNo", "DateOfBirth", "Gender", "Address", "Pincode",
                    "City", "State", "Country", "ApplyFor", "ApplyForOther", "DateOfApplication", "NativePlace",
                    "AlternateMobile", "MaritalStatus", "SpouseName", "SpouseContect", "BloodGroup",
                    "FatherName", "FatherContact", "MotherName", "MotherContact", "Source", "ReferenceBy",
                    "Qualification1", "CollegeName1", "PassingYear1", "Percentage/CGPA1",
                    "Qualification2", "CollegeName2", "PassingYear2", "Percentage/CGPA2",
                    "WorkExpriance", "YeasOfExp.", "MonthsOfExp.", "CompanyName1", "JobTitle1", "Salary1",
                    "FromDate1", "ToDate1", "CurrentlyWorking1", "ReasonOfLeaving1",
                    "CompanyName2", "JobTitle2", "Salary2", "FromDate2", "ToDate2", "CurrentlyWorking2", "ReasonOfLeaving2",
                    "CompanyName3", "JobTitle3", "Salary3", "FromDate3", "ToDate3", "CurrentlyWorking3", "RasonOfLeaving3",
                    "EnglishProficiency", "LanguegesKnown", "ExpectedCTC", "NoticePeriod", "PreferredJoiningDate"
                ];

                const headers = (jsonData[0] || []).map(h => (h ? String(h).trim() : "")).filter(h => h !== "");

                const headersValid = headers.length === expectedHeaders.length &&
                    expectedHeaders.every((header, index) => header === headers[index]);

                if (!headersValid) {
                    const missing = expectedHeaders.filter((h, i) => headers[i] !== h);
                    const errorDetails = missing.length > 0 ? `(Mismatch at column: ${missing[0]})` : "";
                    setSnackbar({
                        open: true,
                        message: `Invalid file format. ${errorDetails}`,
                        severity: "error"
                    });
                    setData([]);
                    setFilteredData([]);
                    updateProgress(0);
                    setShowBuffer(false);
                    return;
                }

                const requiredFields = [
                    { key: 'Name', label: 'Name' },
                    { key: 'EmailId', label: 'Email Id' },
                    { key: 'MobileNo', label: 'Mobile No.' },
                    { key: 'DateOfBirth', label: 'Date Of Birth' },
                    { key: 'Gender', label: 'Gender' },
                    { key: 'Address', label: 'Address' },
                    { key: 'Pincode', label: 'Pincode' },
                    { key: 'City', label: 'City' },
                    { key: 'State', label: 'State' },
                    { key: 'Country', label: 'Country' },
                    { key: 'ApplyFor', label: 'Apply For' },
                    { key: 'DateOfApplication', label: 'Date Of Application' },
                    { key: 'MaritalStatus', label: 'Marital Status' },
                    { key: 'Source', label: 'Source' },
                    { key: 'Qualification1', label: 'Qualification1' },
                    { key: 'CollegeName1', label: 'CollegeName1' },
                    { key: 'PassingYear1', label: 'PassingYear1' },
                    { key: 'Percentage/CGPA1', label: 'Percentage/CGPA1' },
                    { key: 'WorkExpriance', label: 'Work Experience' }
                ];

                const parsedData = jsonData.slice(1).map((row) => {
                    const record = {
                        id: generateUniqueId(),
                        Name: row[0] || "",
                        EmailId: row[1] || "",
                        MobileNo: row[2] || "",
                        DateOfBirth: parseAndFormatDate(row[3]),
                        Gender: row[4] || "",
                        Address: row[5] || "",
                        Pincode: row[6] || "",
                        City: row[7] || "",
                        State: row[8] || "",
                        Country: row[9] || "",
                        ApplyFor: row[10] || "",
                        ApplyForOther: row[11] || "",
                        DateOfApplication: parseAndFormatDate(row[12]),
                        NativePlace: row[13] || "",
                        AlternateMobile: row[14] || "",
                        MaritalStatus: row[15] || "",
                        SpouseName: row[16] || "",
                        SpouseContect: row[17] || "",
                        BloodGroup: row[18] || "",
                        FatherName: row[19] || "",
                        FatherContact: row[20] || "",
                        MotherName: row[21] || "",
                        MotherContact: row[22] || "",
                        Source: row[23] || "",
                        ReferenceBy: row[24] || "",
                        Qualification1: row[25] || "",
                        CollegeName1: row[26] || "",
                        PassingYear1: row[27] || "",
                        'Percentage/CGPA1': row[28] || "",
                        Qualification2: row[29] || "",
                        CollegeName2: row[30] || "",
                        PassingYear2: row[31] || "",
                        'Percentage/CGPA2': row[32] || "",
                        WorkExpriance: row[33] || "",
                        'YeasOfExp.': row[34] || "",
                        'MonthsOfExp.': row[35] || "",
                        CompanyName1: row[36] || "",
                        JobTitle1: row[37] || "",
                        Salary1: row[38] || "",
                        FromDate1: parseAndFormatDate(row[39]),
                        ToDate1: parseAndFormatDate(row[40]),
                        CurrentlyWorking1: row[41] || "",
                        ReasonOfLeaving1: row[42] || "",
                        CompanyName2: row[43] || "",
                        JobTitle2: row[44] || "",
                        Salary2: row[45] || "",
                        FromDate2: parseAndFormatDate(row[46]),
                        ToDate2: parseAndFormatDate(row[47]),
                        CurrentlyWorking2: row[48] || "",
                        ReasonOfLeaving2: row[49] || "",
                        CompanyName3: row[50] || "",
                        JobTitle3: row[51] || "",
                        Salary3: row[52] || "",
                        FromDate3: parseAndFormatDate(row[53]),
                        ToDate3: parseAndFormatDate(row[54]),
                        CurrentlyWorking3: row[55] || "",
                        RasonOfLeaving3: row[56] || "",
                        EnglishProficiency: row[57] || "",
                        LanguegesKnown: row[58] || "",
                        ExpectedCTC: row[59] || "",
                        NoticePeriod: row[60] || "",
                        PreferredJoiningDate: parseAndFormatDate(row[61])
                    };

                    const missing = requiredFields
                        .filter(f => !record[f.key] || String(record[f.key]).trim() === '')
                        .map(f => f.label);

                    const validationErrors = [];

                    if (record.EmailId && !isValidEmail(record.EmailId)) {
                        validationErrors.push("Email Id must contain @ and .");
                    }

                    const mobileStr = record.MobileNo?.toString().trim();
                    if (mobileStr && !/^\d{10}$/.test(mobileStr)) {
                        validationErrors.push("Mobile No. must be 10 digits");
                    }

                    const altMobileStr = record.AlternateMobile?.toString().trim();
                    if (altMobileStr && !/^\d{10}$/.test(altMobileStr)) {
                        validationErrors.push("Alternate Mobile must be 10 digits");
                    }

                    const fatherContactStr = record.FatherContact?.toString().trim();
                    if (fatherContactStr && !/^\d{10}$/.test(fatherContactStr)) {
                        validationErrors.push("Father Contact must be 10 digits");
                    }

                    const motherContactStr = record.MotherContact?.toString().trim();
                    if (motherContactStr && !/^\d{10}$/.test(motherContactStr)) {
                        validationErrors.push("Mother Contact must be 10 digits");
                    }

                    if (record.DateOfBirth && !isValidDateFormat(record.DateOfBirth)) {
                        validationErrors.push("Date Of Birth must be in DD-MM-YYYY format");
                    }

                    if (record.Gender && !['Male', 'Female', 'Other'].includes(record.Gender.trim())) {
                        validationErrors.push("Gender must be Male, Female, or Other");
                    }

                    const pincodeStr = record.Pincode?.toString().trim();
                    if (pincodeStr && !/^\d{6}$/.test(pincodeStr)) {
                        validationErrors.push("Pincode must be 6 digits");
                    }

                    if (record.DateOfApplication && !isValidDateFormat(record.DateOfApplication)) {
                        validationErrors.push("Date Of Application must be in DD-MM-YYYY format");
                    }

                    if (record.MaritalStatus) {
                        const maritalStatus = record.MaritalStatus.trim();

                        if (maritalStatus === 'Yes' || maritalStatus === 'Married') {
                            if (isEmpty(record.SpouseName)) {
                                validationErrors.push("Spouse Name is required when Marital Status is Yes/Married");
                            }
                            if (isEmpty(record.SpouseContect)) {
                                validationErrors.push("Spouse Contact is required when Marital Status is Yes/Married");
                            } else {
                                const spouseContactStr = record.SpouseContect?.toString().trim();
                                if (!/^\d{10}$/.test(spouseContactStr)) {
                                    validationErrors.push("Spouse Contact must be 10 digits");
                                }
                            }
                        }
                    }

                    const qual2Fields = ['Qualification2', 'CollegeName2', 'PassingYear2', 'Percentage/CGPA2'];
                    if (hasAnyFieldData(record, qual2Fields)) {
                        const qual2RequiredFields = ['Qualification2', 'CollegeName2', 'PassingYear2', 'Percentage/CGPA2'];
                        qual2RequiredFields.forEach(field => {
                            if (isEmpty(record[field])) {
                                validationErrors.push(`${field} is required for Qualification2`);
                            }
                        });

                        if (record.PassingYear2 && !isValidYear(record.PassingYear2)) {
                            validationErrors.push("Passing Year2 must be a valid year (1900-current)");
                        }
                    }

                    if (record.WorkExpriance) {
                        const workExp = record.WorkExpriance.trim();

                        if (workExp === 'Yes') {
                            const exp1RequiredFields = ['YeasOfExp.', 'MonthsOfExp.', 'CompanyName1', 'JobTitle1', 'Salary1', 'FromDate1', 'ToDate1', 'ReasonOfLeaving1'];
                            exp1RequiredFields.forEach(field => {
                                if (isEmpty(record[field])) {
                                    const fieldLabel = field === 'YeasOfExp.' ? 'Years Of Exp' : field === 'MonthsOfExp.' ? 'Months Of Exp' : field;
                                    validationErrors.push(`${fieldLabel} is required for Work Experience Yes`);
                                }
                            });

                            if (record.FromDate1 && !isValidDateFormat(record.FromDate1)) {
                                validationErrors.push("FromDate1 must be in DD-MM-YYYY format");
                            }
                            if (record.ToDate1 && !isValidDateFormat(record.ToDate1)) {
                                validationErrors.push("ToDate1 must be in DD-MM-YYYY format");
                            }

                            const company2Fields = ['CompanyName2', 'JobTitle2', 'Salary2', 'FromDate2', 'ToDate2', 'ReasonOfLeaving2'];
                            if (hasAnyFieldData(record, company2Fields)) {
                                const company2RequiredFields = ['CompanyName2', 'JobTitle2', 'Salary2', 'FromDate2', 'ToDate2', 'ReasonOfLeaving2'];
                                const company2FieldLabels = {
                                    'CompanyName2': 'CompanyName2',
                                    'JobTitle2': 'JobTitle2',
                                    'Salary2': 'Salary2',
                                    'FromDate2': 'FromDate2',
                                    'ToDate2': 'ToDate2',
                                    'ReasonOfLeaving2': 'ReasonOfLeaving2'
                                };
                                company2RequiredFields.forEach(field => {
                                    if (isEmpty(record[field])) {
                                        validationErrors.push(`${company2FieldLabels[field]} is required for Company2`);
                                    }
                                });

                                if (record.FromDate2 && !isValidDateFormat(record.FromDate2)) {
                                    validationErrors.push("FromDate2 must be in DD-MM-YYYY format");
                                }
                                if (record.ToDate2 && !isValidDateFormat(record.ToDate2)) {
                                    validationErrors.push("ToDate2 must be in DD-MM-YYYY format");
                                }
                            }

                            const company3Fields = ['CompanyName3', 'JobTitle3', 'Salary3', 'FromDate3', 'ToDate3', 'RasonOfLeaving3'];
                            if (hasAnyFieldData(record, company3Fields)) {
                                const company3RequiredFields = ['CompanyName3', 'JobTitle3', 'Salary3', 'FromDate3', 'ToDate3', 'RasonOfLeaving3'];
                                const company3FieldLabels = {
                                    'CompanyName3': 'CompanyName3',
                                    'JobTitle3': 'JobTitle3',
                                    'Salary3': 'Salary3',
                                    'FromDate3': 'FromDate3',
                                    'ToDate3': 'ToDate3',
                                    'RasonOfLeaving3': 'RasonOfLeaving3'
                                };
                                company3RequiredFields.forEach(field => {
                                    if (isEmpty(record[field])) {
                                        validationErrors.push(`${company3FieldLabels[field]} is required for Company3`);
                                    }
                                });

                                if (record.FromDate3 && !isValidDateFormat(record.FromDate3)) {
                                    validationErrors.push("FromDate3 must be in DD-MM-YYYY format");
                                }
                                if (record.ToDate3 && !isValidDateFormat(record.ToDate3)) {
                                    validationErrors.push("ToDate3 must be in DD-MM-YYYY format");
                                }
                            }
                        } else if (workExp !== 'No') {
                            validationErrors.push("Work Experience must be Yes or No");
                        }
                    }

                    if (record.PassingYear1 && !isValidYear(record.PassingYear1)) {
                        validationErrors.push("Passing Year1 must be a valid year (1900-current)");
                    }

                    record._missingFields = [...missing, ...validationErrors];

                    return record;
                }).filter(row =>
                    row.Name || row.EmailId || row.MobileNo
                );

                setData(parsedData);
                setFilteredData(parsedData);
                setInsertedIds(new Set());
                setFadeOutIds(new Set());
                setRowStatus({});

                updateProgress(50);
                setSnackbar({ open: true, message: `Successfully parsed ${parsedData.length} records`, severity: "success" });

                updateProgress(100);
                setTimeout(() => {
                    setShowBuffer(false);
                    updateProgress(0);
                }, 800);
            } catch (err) {
                console.error(err);
                setSnackbar({ open: true, message: "Error parsing file", severity: "error" });
                setData([]);
                setFilteredData([]);
                updateProgress(0);
                setShowBuffer(false);
            }
        };

        reader.onerror = () => {
            setSnackbar({ open: true, message: "Error reading file", severity: "error" });
            setData([]);
            setFilteredData([]);
            updateProgress(0);
            setShowBuffer(false);
        };

        reader.readAsBinaryString(file);
    };

    const convertDateFormat = (dateStr) => {
        if (!dateStr) return null;

        const str = String(dateStr).trim();

        if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
            return str;
        }

        if (/^\d{2}[-\/]\d{2}[-\/]\d{4}$/.test(str)) {
            const parts = str.split(/[-\/]/);
            const day = parts[0];
            const month = parts[1];
            const year = parts[2];

            const dateObj = new Date(year, month - 1, day);
            if (isNaN(dateObj.getTime())) {
                return null;
            }

            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        }

        return null;
    };

    const handleUploadSubmit = async () => {
        if (!data.length) {
            setSnackbar({ open: true, message: "No data to upload", severity: "error" });
            return;
        }

        const validRows = data.filter(r => !r._missingFields || r._missingFields.length === 0);
        const errorRows = data.filter(r => r._missingFields?.length > 0);

        if (validRows.length === 0) {
            setSnackbar({ open: true, message: "All rows contain errors – nothing to insert", severity: "error" });
            return;
        }

        if (!companyId || !userId) {
            setSnackbar({ open: true, message: "Missing company/user data", severity: "error" });
            return;
        }

        setUploading(true);
        setShowBuffer(true);
        updateProgress(0);

        let insertedCount = 0;
        let existsCount = 0;
        let failedCount = 0;
        const insertedRowIds = [];

        try {
            for (let i = 0; i < validRows.length; i++) {
                const row = validRows[i];

                const education = [];

                if (row.Qualification1 || row.CollegeName1 || row.PassingYear1 || row['Percentage/CGPA1']) {
                    education.push({
                        qualification: row.Qualification1 || null,
                        collegeName: row.CollegeName1 || null,
                        passingYear: row.PassingYear1 || null,
                        percentage: row['Percentage/CGPA1'] ? Number(row['Percentage/CGPA1']) : null
                    });
                }

                if (row.Qualification2 || row.CollegeName2 || row.PassingYear2 || row['Percentage/CGPA2']) {
                    education.push({
                        qualification: row.Qualification2 || null,
                        collegeName: row.CollegeName2 || null,
                        passingYear: row.PassingYear2 || null,
                        percentage: row['Percentage/CGPA2'] ? Number(row['Percentage/CGPA2']) : null
                    });
                }

                const experienceDetails = [];

                if (row.CompanyName1 || row.JobTitle1 || row.Salary1 || row.FromDate1 || row.ToDate1 || row.ReasonOfLeaving1) {
                    experienceDetails.push({
                        companyName: row.CompanyName1 || null,
                        jobTitle: row.JobTitle1 || null,
                        salaryPerMonth: row.Salary1 ? Number(row.Salary1) : null,
                        reasonForLeaving: row.ReasonOfLeaving1 || null,
                        fromDate: convertDateFormat(row.FromDate1) || null,
                        toDate: convertDateFormat(row.ToDate1) || null,
                        currentlyWorking: row.CurrentlyWorking1 ? 1 : 0
                    });
                }

                if (row.CompanyName2 || row.JobTitle2 || row.Salary2 || row.FromDate2 || row.ToDate2 || row.ReasonOfLeaving2) {
                    experienceDetails.push({
                        companyName: row.CompanyName2 || null,
                        jobTitle: row.JobTitle2 || null,
                        salaryPerMonth: row.Salary2 ? Number(row.Salary2) : null,
                        reasonForLeaving: row.ReasonOfLeaving2 || null,
                        fromDate: convertDateFormat(row.FromDate2) || null,
                        toDate: convertDateFormat(row.ToDate2) || null,
                        currentlyWorking: row.CurrentlyWorking2 ? 1 : 0
                    });
                }

                if (row.CompanyName3 || row.JobTitle3 || row.Salary3 || row.FromDate3 || row.ToDate3 || row.RasonOfLeaving3) {
                    experienceDetails.push({
                        companyName: row.CompanyName3 || null,
                        jobTitle: row.JobTitle3 || null,
                        salaryPerMonth: row.Salary3 ? Number(row.Salary3) : null,
                        reasonForLeaving: row.RasonOfLeaving3 || null,
                        fromDate: convertDateFormat(row.FromDate3) || null,
                        toDate: convertDateFormat(row.ToDate3) || null,
                        currentlyWorking: row.CurrentlyWorking3 ? 1 : 0
                    });
                }

                const payload = {
                    meta: {
                        GCompId: null,
                        CompId: companyId,
                        FYear: fYear,
                        userId: userId,
                        BranchId: null
                    },

                    personal: {
                        CandidateName: row.Name,
                        MobileNo: row.MobileNo?.toString(),
                        EmailId: row.EmailId,
                        DOB: convertDateFormat(row.DateOfBirth),
                        Gender: row.Gender,
                        Address: row.Address,
                        city: row.City || "",
                        state: row.State || "",
                        country: row.Country || "",
                        NativePlace: row.NativePlace || "",
                        AppliedFor: row.ApplyFor,
                        ApplyForOther: row.ApplyForOther || "",
                        pinCode: row.Pincode ? Number(row.Pincode) : null,
                        dateOfApplication: convertDateFormat(row.DateOfApplication),
                        altMobileNo: row.AlternateMobile || "",
                        maritalStatus: row.MaritalStatus,
                        spouseName: row.SpouseName || "",
                        spouseContact: row.SpouseContect || "",
                        bloodGroup: row.BloodGroup || "",
                        fatherName: row.FatherName || "",
                        fatherContact: row.FatherContact || "",
                        motherName: row.MotherName || "",
                        motherContact: row.MotherContact || "",
                        Source: row.Source,
                        ReferenceBy: row.ReferenceBy || ""
                    },

                    education: education,

                    experience: {
                        ExperienceYears: row['YeasOfExp.'] ? Number(row['YeasOfExp.']) : null,
                        ExperienceMonths: row['MonthsOfExp.'] ? Number(row['MonthsOfExp.']) : null,
                        experienceDetails: experienceDetails
                    },

                    preference: {
                        salaryExpected: row.ExpectedCTC ? Number(row.ExpectedCTC) : null,
                        joiningDate: convertDateFormat(row.PreferredJoiningDate),
                        noticePeriod: row.NoticePeriod || "",
                        englishProficiency: row.EnglishProficiency || "",
                        languagesKnown: row.LanguegesKnown || ""
                    }
                };

                console.log(`[${i + 1}/${validRows.length}] Uploading: ${row.Name}`);

                try {
                    const response = await axios.post(`${path}/candidate/insert`, payload, {
                        validateStatus: (status) => [200, 201, 204, 304, 500].includes(status)
                    });

                    const status = response.status;
                    let message = "";

                    if (status === 201) {
                        message = "Inserted";
                        insertedCount++;
                        insertedRowIds.push(row.id);
                        console.log(`✅ [${i + 1}/${validRows.length}] ${row.Name} - Inserted successfully`);
                    } else if (status === 204 || status === 304) {
                        message = "Already Exists";
                        existsCount++;
                        console.log(`⚠️  [${i + 1}/${validRows.length}] ${row.Name} - Already exists`);
                    } else {
                        message = "Failed";
                        failedCount++;
                        console.error(`❌ [${i + 1}/${validRows.length}] ${row.Name} - Failed`, response.data);
                    }

                    setRowStatus(prev => ({
                        ...prev,
                        [row.id]: { status, message }
                    }));

                } catch (err) {
                    console.error(`❌ [${i + 1}/${validRows.length}] ${row.Name} - Error:`, err.response?.data || err.message);
                    const status = err.response?.status || 500;

                    setRowStatus(prev => ({
                        ...prev,
                        [row.id]: { status, message: "Failed" }
                    }));

                    failedCount++;
                }

                const progressPercentage = Math.round(((i + 1) / validRows.length) * 100);
                updateProgress(progressPercentage);

                console.log(`Progress: ${progressPercentage}% (${i + 1}/${validRows.length})`);

                if (i < validRows.length - 1) {
                    await new Promise(resolve => setTimeout(resolve, 100));
                }
            }

            const parts = [];
            if (insertedCount) parts.push(`✅ ${insertedCount} Inserted`);
            if (existsCount) parts.push(`⚠️  ${existsCount} Already Exists`);
            if (failedCount) parts.push(`❌ ${failedCount} Failed`);
            if (errorRows.length) parts.push(`⏭️  ${errorRows.length} Skipped (errors)`);

            setSnackbar({
                open: true,
                message: parts.join(" | "),
                severity: insertedCount > 0 ? "success" : "warning"
            });

            setTimeout(() => {
                const sortedFadeIds = insertedRowIds
                    .map(id => ({ id, name: data.find(r => r.id === id)?.Name || "" }))
                    .sort((a, b) => (a.name || "").localeCompare(b.name || ""))
                    .map(item => item.id);

                sortedFadeIds.forEach((id, index) => {
                    setTimeout(() => {
                        setFadeOutIds(prev => new Set(prev).add(id));
                    }, index * 300);
                });

                setTimeout(() => {
                    setData(prev => prev.filter(r => !insertedRowIds.includes(r.id)));
                    setInsertedIds(new Set());
                    setFadeOutIds(new Set());
                    setRowStatus({});
                }, sortedFadeIds.length * 300 + 600);
            }, 1000);

        } catch (error) {
            console.error("Unexpected error:", error);
            setSnackbar({ open: true, message: "Unexpected error occurred", severity: "error" });
        } finally {
            setUploading(false);
            setShowBuffer(false);
        }
    };

    const handleBackClick = () => { navigate("/main/CandidateDetails"); };

    const sortedData = useMemo(() => {
        const withError = data.filter(r => (r._missingFields?.length || 0) > 0);
        const withoutError = data.filter(r => !r._missingFields || r._missingFields.length === 0);

        const sortedWithoutError = [...withoutError].sort((a, b) => {
            const nameA = (a.Name || "").trim().toLowerCase();
            const nameB = (b.Name || "").trim().toLowerCase();
            return nameA.localeCompare(nameB);
        });

        return [...withError, ...sortedWithoutError];
    }, [data]);

    const filteredDataFinal = useMemo(() => {
        let result = sortedData;

        if (filterMode === 'perfect') {
            result = result.filter(r => !r._missingFields || r._missingFields.length === 0);
        } else if (filterMode === 'error') {
            result = result.filter(r => r._missingFields?.length > 0);
        }

        if (searchText.trim()) {
            const lowerSearch = searchText.toLowerCase();
            result = result.filter(row =>
                row.Name?.toLowerCase().includes(lowerSearch) ||
                row.MobileNo?.toLowerCase().includes(lowerSearch) ||
                row.EmailId?.toLowerCase().includes(lowerSearch)
            );
        }

        return result;
    }, [sortedData, filterMode, searchText]);

    useMemo(() => {
        setFilteredData(filteredDataFinal);
    }, [filteredDataFinal]);

    const errorCount = useMemo(() => data.filter(r => r._missingFields?.length > 0).length, [data]);
    const perfectCount = useMemo(() => data.length - errorCount, [data]);
    const validRowsCount = useMemo(() => data.filter(r => !r._missingFields || r._missingFields.length === 0).length, [data]);

    const fieldGroups = [
        {
            title: "Personal Info",
            icon: <PersonIcon fontSize="small" />,
            fields: [
                { label: "Name", key: "Name" },
                { label: "Email Id", key: "EmailId" },
                { label: "Mobile No.", key: "MobileNo" },
                { label: "Alternate Mobile", key: "AlternateMobile" },
                { label: "Date Of Birth", key: "DateOfBirth" },
                { label: "Gender", key: "Gender" },
            ]
        },
        {
            title: "Address & Location",
            icon: <LocationOnIcon fontSize="small" />,
            fields: [
                { label: "Address", key: "Address" },
                { label: "City", key: "City" },
                { label: "State", key: "State" },
                { label: "Pincode", key: "Pincode" },
                { label: "Country", key: "Country" },
                { label: "Native Place", key: "NativePlace" },
            ]
        },
        {
            title: "Application & Family",
            icon: <EmailIcon fontSize="small" />,
            fields: [
                { label: "Apply For", key: "ApplyFor" },
                { label: "Apply For Other", key: "ApplyForOther" },
                { label: "Date Of Application", key: "DateOfApplication" },
                { label: "Marital Status", key: "MaritalStatus" },
                { label: "Spouse Name", key: "SpouseName" },
                { label: "Spouse Contact", key: "SpouseContect" },
                { label: "Blood Group", key: "BloodGroup" },
                { label: "Father Name", key: "FatherName" },
                { label: "Father Contact", key: "FatherContact" },
                { label: "Mother Name", key: "MotherName" },
                { label: "Mother Contact", key: "MotherContact" },
            ]
        },
        {
            title: "Education",
            icon: <SchoolIcon fontSize="small" />,
            fields: [
                { label: "Qualification1", key: "Qualification1" },
                { label: "CollegeName1", key: "CollegeName1" },
                { label: "PassingYear1", key: "PassingYear1" },
                { label: "Percentage/CGPA1", key: "Percentage/CGPA1" },
                { label: "Qualification2", key: "Qualification2" },
                { label: "CollegeName2", key: "CollegeName2" },
                { label: "PassingYear2", key: "PassingYear2" },
                { label: "Percentage/CGPA2", key: "Percentage/CGPA2" },
            ]
        },
        {
            title: "Work Experience",
            icon: <WorkIcon fontSize="small" />,
            fields: [
                { label: "Work Experience", key: "WorkExpriance" },
                { label: "Years Of Exp", key: "YeasOfExp." },
                { label: "Months Of Exp", key: "MonthsOfExp." },
                { label: "CompanyName1", key: "CompanyName1" },
                { label: "JobTitle1", key: "JobTitle1" },
                { label: "Salary1", key: "Salary1" },
                { label: "FromDate1", key: "FromDate1" },
                { label: "ToDate1", key: "ToDate1" },
                { label: "Currently Working1", key: "CurrentlyWorking1" },
                { label: "ReasonOfLeaving1", key: "ReasonOfLeaving1" },
                { label: "CompanyName2", key: "CompanyName2" },
                { label: "JobTitle2", key: "JobTitle2" },
                { label: "Salary2", key: "Salary2" },
                { label: "FromDate2", key: "FromDate2" },
                { label: "ToDate2", key: "ToDate2" },
                { label: "Currently Working2", key: "CurrentlyWorking2" },
                { label: "ReasonOfLeaving2", key: "ReasonOfLeaving2" },
                { label: "CompanyName3", key: "CompanyName3" },
                { label: "JobTitle3", key: "JobTitle3" },
                { label: "Salary3", key: "Salary3" },
                { label: "FromDate3", key: "FromDate3" },
                { label: "ToDate3", key: "ToDate3" },
                { label: "Currently Working3", key: "CurrentlyWorking3" },
                { label: "ReasonOfLeaving3", key: "RasonOfLeaving3" },
            ]
        },
        {
            title: "Additional Info",
            icon: <PhoneIcon fontSize="small" />,
            fields: [
                { label: "Source", key: "Source" },
                { label: "Reference By", key: "ReferenceBy" },
                { label: "English Proficiency", key: "EnglishProficiency" },
                { label: "Languages Known", key: "LanguegesKnown" },
                { label: "Expected CTC", key: "ExpectedCTC" },
                { label: "Notice Period", key: "NoticePeriod" },
                { label: "Preferred Joining Date", key: "PreferredJoiningDate" },
            ]
        }
    ];

    return (
        <Container sx={{ pt: { xs: 1, sm: 2 }, pb: { xs: 1, sm: 2 }, px: { xs: 1, sm: 2 }, maxWidth: { xs: "100%", sm: "100%", md: "1400px" } }}>
            {/* Header Section */}
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, gap: 2, flexWrap: "wrap" }}>
                <Box>
                    <Typography variant="h4" sx={{ fontWeight: 700, background: gradients.primary, backgroundClip: "text", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", fontSize: { xs: "1.5rem", sm: "2rem", md: "2.25rem" }, letterSpacing: "-0.5px" }} >
                        Candidate Data Upload
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            color: "text.secondary",
                            mt: 0.5,
                            fontSize: { xs: "0.8rem", sm: "0.95rem" }
                        }}
                    >
                        Manage and import your candidate information
                    </Typography>
                </Box>
                <Tooltip title="Back to Candidate Details" placement="left">
                    <IconButton onClick={handleBackClick} sx={{ bgcolor: colors.primary.main, color: "white", width: { xs: 40, sm: 48 }, height: { xs: 40, sm: 48 }, "&:hover": { bgcolor: colors.primary.dark, transform: "translateY(-2px)", boxShadow: "0 6px 16px rgba(25, 118, 210, 0.4)" }, borderRadius: 1.5, transition: "all 0.3s ease", boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)", flexShrink: 0 }} >
                        <ArrowBackIcon sx={{ fontSize: { xs: 22, sm: 26 } }} />
                    </IconButton>
                </Tooltip>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                {/* File Upload Card */}
                <Paper sx={{ px: { xs: 3, sm: 3.5 }, py: { xs: 2, sm: 2.5 }, borderRadius: { xs: 2.5, sm: 3 }, bgcolor: "background.paper", boxShadow: "0 4px 16px rgba(25, 118, 210, 0.4)", border: `1px solid ${alpha(colors.primary.main, 0.1)}`, position: "relative", overflow: "hidden", "&::before": { content: '""', position: "absolute", top: 0, left: 0, right: 0, height: 1, background: `linear-gradient(90deg, transparent, rgba(25, 118, 210, 0.3), transparent)`, } }}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        <FileUploadZone fileInputRef={fileInputRef} file={file} handleFileChange={handleFileChange} data={data} />

                        {(file || data.length > 0) && (
                            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: { xs: "space-between", sm: "flex-start" } }}>
                                <Button variant="contained" onClick={handleUploadSubmit} disabled={uploading || !data.length || validRowsCount === 0} sx={{
                                        height: { xs: 40, sm: 44 },
                                        bgcolor: colors.primary.main,
                                        "&:hover": { bgcolor: colors.primary.dark, boxShadow: "0 6px 20px rgba(25, 118, 210, 0.4)", transform: "translateY(-2px)" }, borderRadius: 1.5, textTransform: "none", fontWeight: 700, px: { xs: 2, sm: 3 }, "&.Mui-disabled": { bgcolor: themeColors.neutral.lineStrong, color: themeColors.neutral.sub }, fontSize: { xs: "0.95rem", sm: "1.05rem" }, minWidth: { xs: "auto", sm: 140 }, transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)", boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)", gap: 1 }} >
                                    {uploading ? <CircularProgress size={22} color="inherit" /> : <InsertDriveFileIcon sx={{ fontSize: 22 }} />}
                                    {uploading ? "Uploading..." : "Upload Records"}
                                </Button>
                                {showBuffer && (
                                    <Box sx={{ width: { xs: "100%", sm: 280 } }}>
                                        <LinearProgress variant="buffer" value={progressValue} valueBuffer={bufferValue} sx={{ height: 4, borderRadius: 4, backgroundColor: alpha(colors.primary.main, 0.1), "& .MuiLinearProgress-bar": { borderRadius: 4, background: gradients.primaryRow } }} />
                                        <Typography variant="caption" sx={{ display: "block", textAlign: "center", fontSize: { xs: "0.75rem", sm: "0.85rem" }, fontWeight: 600, color: colors.primary.main }} >
                                            {uploading ? `${Math.round(progressValue)}%` : `Ready`}
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        )}

                        {data.length > 0 && (
                            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", justifyContent: { xs: "center", sm: "flex-end" } }}>
                                <Chip icon={<CheckCircleIcon sx={{ fontSize: 18 }} />} label={`${perfectCount} Valid`} onClick={() => setFilterMode(prev => prev === 'perfect' ? 'all' : 'perfect')} variant={filterMode === 'perfect' ? "filled" : "outlined"} sx={{ bgcolor: filterMode === 'perfect' ? themeColors.success.main : 'transparent', color: filterMode === 'perfect' ? 'white' : themeColors.success.main, fontWeight: 700, border: filterMode === 'perfect' ? 'none' : `2px solid ${themeColors.success.main}`, cursor: 'pointer', transition: 'all 0.3s ease', '&:hover': { bgcolor: filterMode === 'perfect' ? '#388e3c' : alpha(themeColors.success.main, 0.08), transform: 'translateY(-2px)', boxShadow: '0 4px 12px rgba(76, 175, 80, 0.3)' }, fontSize: { xs: "0.8rem", sm: "0.95rem" } }} />
                                <Chip icon={<ErrorIcon sx={{ fontSize: 18 }} />} label={`${errorCount} Errors`} onClick={() => setFilterMode(prev => prev === 'error' ? 'all' : 'error')} variant={filterMode === 'error' ? "filled" : "outlined"} sx={{ bgcolor: filterMode === 'error' ? themeColors.error.main : 'transparent', color: filterMode === 'error' ? 'white' : themeColors.error.main, fontWeight: 700, border: filterMode === 'error' ? 'none' : `2px solid ${themeColors.error.main}`, cursor: 'pointer', transition: 'all 0.3s ease', '&:hover': { bgcolor: filterMode === 'error' ? themeColors.error.dark : alpha(themeColors.error.main, 0.08), transform: 'translateY(-2px)', boxShadow: '0 4px 12px rgba(244, 67, 54, 0.3)' }, fontSize: { xs: "0.8rem", sm: "0.95rem" } }} />
                            </Box>
                        )}
                    </Box>
                </Paper>

                {data.length > 0 && (
                    <GlassParentCard>
                        <Box p={{ xs: 1, sm: 1.5 }} pb={1.5}>
                            <TextField fullWidth size="small" placeholder={isMobile ? "Search candidates..." : "Search by name, phone, email..."} value={searchText} onChange={(e) => setSearchText(e.target.value)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon sx={{ fontSize: 22, color: colors.primary.main }} />
                                        </InputAdornment>
                                    ),
                                }}
                                sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: "background.paper", fontSize: { xs: "0.9rem", sm: "1rem" }, border: `1.5px solid ${alpha(colors.primary.main, 0.2)}`, transition: "all 0.3s ease", "&:hover": { borderColor: alpha(colors.primary.main, 0.4) }, "&.Mui-focused": { borderColor: colors.primary.main, boxShadow: `0 0 0 3px ${alpha(colors.primary.main, 0.1)}` } } }}
                            />
                        </Box>

                        <Box flex={1} overflow="auto" p={{ xs: 1.5, sm: 2 }} pt={0} sx={{ maxHeight: { xs: "calc(100vh - 380px)", sm: "calc(100vh - 300px)", md: "calc(78vh - 80px)" }, '&::-webkit-scrollbar': { width: '8px' }, '&::-webkit-scrollbar-track': { background: alpha(colors.primary.main, 0.05), borderRadius: '10px' }, '&::-webkit-scrollbar-thumb': { background: colors.primary.main, borderRadius: '10px', '&:hover': { background: colors.primary.dark } } }} >
                            <Stack spacing={{ xs: 1.5, sm: 2, md: 2.5 }}>
                                {filteredData.length === 0 ? (
                                    <Paper sx={{ p: 2.5, textAlign: "center", borderRadius: 3, bgcolor: alpha(colors.primary.main, 0.02), border: `1px dashed ${alpha(colors.primary.main, 0.2)}` }}>
                                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
                                            <SearchIcon sx={{ fontSize: 48, color: alpha(colors.primary.main, 0.3), mb: 1 }} />
                                            <Typography variant="h6" color="text.secondary" sx={{ fontSize: { xs: "1rem", sm: "1.1rem" }, fontWeight: 600 }}>
                                                {searchText || filterMode !== 'all' ? "No records match your search" : "No data loaded"}
                                            </Typography>
                                        </Box>
                                    </Paper>
                                ) : (
                                    filteredData.map((r, idx) => {
                                        const missing = r._missingFields || [];
                                        const isError = missing.length > 0;
                                        const expanded = expandedCards[r.id];
                                        const statusInfo = rowStatus[r.id];
                                        const isFading = fadeOutIds.has(r.id);

                                        let cardBg = "background.paper";
                                        let borderColor = alpha(colors.primary.main, 0.2);
                                        let statusChip = null;

                                        if (statusInfo) {
                                            if (statusInfo.status === 201) {
                                                cardBg = "#e8f5e9";
                                                borderColor = themeColors.success.main;
                                                statusChip = { color: "#1b5e20", bg: themeColors.success.main, icon: <CheckCircleOutlineIcon sx={{ fontSize: 14 }} />, label: "✓ Inserted" };
                                            } else if ([204, 304].includes(statusInfo.status)) {
                                                cardBg = "#fff8e1";
                                                borderColor = themeColors.warning.main;
                                                statusChip = { color: "#ff8f00", bg: themeColors.warning.main, icon: <WarningIcon sx={{ fontSize: 14 }} />, label: "Already Exists" };
                                            } else {
                                                cardBg = "#ffebee";
                                                borderColor = themeColors.error.main;
                                                statusChip = { color: themeColors.error.darker, bg: themeColors.error.main, icon: <ErrorIcon sx={{ fontSize: 14 }} />, label: "Failed" };
                                            }
                                        } else if (isError) {
                                            cardBg = "#ffebee";
                                            borderColor = themeColors.error.main;
                                        }

                                        return (
                                            <Card key={r.id} elevation={isError ? 4 : 2} sx={{ borderRadius: { xs: 2, sm: 2.5, md: 3 }, bgcolor: cardBg, border: `2px solid ${borderColor}`, position: "relative", overflow: "visible", transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)", opacity: isFading ? 0 : 1, transform: isFading ? "translateY(-20px) scale(0.95)" : "translateY(0)", height: isFading ? 0 : "auto", marginBottom: isFading ? "-10px" : { xs: 1, sm: 2 }, padding: isFading ? 0 : { xs: 1, sm: 1.5 }, "&:hover": { boxShadow: isError ? "0 12px 28px rgba(244, 67, 54, 0.15)" : "0 12px 28px rgba(25, 118, 210, 0.15)", } }} >
                                                {statusChip && !isFading && (
                                                    <Box sx={{ position: "absolute", bottom: 8, right: 12, bgcolor: statusChip.bg, color: statusChip.bg === themeColors.warning.main ? themeColors.neutral.black : 'white', px: 1.25, py: 0.4, borderRadius: 1.5, fontSize: { xs: "0.7rem", sm: "0.8rem" }, fontWeight: 700, display: "flex", alignItems: "center", gap: 0.5, zIndex: 1, boxShadow: `0 2px 8px ${alpha(statusChip.bg, 0.3)}` }} >
                                                        {statusChip.icon}
                                                        {statusChip.label}
                                                    </Box>
                                                )}

                                                <CardContent sx={{ pt: { xs: 2, sm: 2.5 }, pb: statusChip ? { xs: 4, sm: 5 } : { xs: 1.5, sm: 2 }, px: { xs: 1.5, sm: 2.5 } }}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: { xs: 1.5, sm: 2, md: 4 }, flexWrap: { xs: "wrap", sm: "nowrap" } }} >
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1.5, sm: 2.5 }, flex: { xs: "0 0 100%", sm: 1 } }}>
                                                            <Box sx={{ background: statusInfo?.status === 201 ? `linear-gradient(135deg, ${themeColors.success.main}, #66bb6a)` : (isError ? `linear-gradient(135deg, ${themeColors.error.main}, #ef5350)` : gradients.primary), color: "white", width: { xs: 40, sm: 48 }, height: { xs: 40, sm: 48 }, borderRadius: 2, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, flexShrink: 0, fontSize: { xs: "1.1rem", sm: "1.3rem" }, boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)" }} >
                                                                {r.Name?.[0]?.toUpperCase() || "?"}
                                                            </Box>
                                                            <Box sx={{ minWidth: 0, flex: 1 }}>
                                                                <Typography variant="h6" fontWeight={700} noWrap sx={{ fontSize: { xs: "1rem", sm: "1.1rem", md: "1.3rem" }, letterSpacing: "-0.3px" }} >
                                                                    {r.Name || "Unnamed"}
                                                                </Typography>
                                                                <Typography variant="body2" color="text.secondary" noWrap sx={{ fontSize: { xs: "0.75rem", sm: "0.9rem" }, mt: 0.25 }} >
                                                                    {r.ApplyFor || "—"} • {r.MobileNo || "—"}
                                                                </Typography>
                                                            </Box>
                                                        </Box>

                                                        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: "1fr 1fr", sm: "repeat(4, 1fr)" }, gap: { xs: 1.25, sm: 1.75 }, alignItems: 'flex-start', flex: { xs: "0 0 100%", sm: "auto" }, width: { xs: "100%", sm: "auto" } }} >
                                                            {[
                                                                { label: "Gender", value: r.Gender || "—", key: "Gender", icon: "👤" },
                                                                { label: "Email", value: r.EmailId || "—", key: "EmailId", icon: "✉️" },
                                                                { label: "DOB", value: r.DateOfBirth || "—", key: "DateOfBirth", icon: "📅" },
                                                                { label: "Location", value: `${r.City || ""}, ${r.State || ""}`.trim() || "—", key: "City", icon: "📍" }
                                                            ].map((item, i) => {
                                                                const hasErr = hasFieldError(r, item.key);
                                                                return (
                                                                    <Box key={i} sx={{ bgcolor: hasErr ? alpha(themeColors.error.main, 0.08) : alpha(colors.primary.main, 0.04), borderRadius: 1.5, p: 1, transition: 'all 0.2s ease', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', minWidth: 0, border: `1px solid ${hasErr ? alpha(themeColors.error.main, 0.2) : alpha(colors.primary.main, 0.1)}` }} >
                                                                        <Typography variant="caption" sx={{ fontWeight: 700, color: hasErr ? themeColors.error.main : 'text.secondary', lineHeight: 1.3, fontSize: { xs: "0.7rem", sm: "0.8rem" }, textTransform: "uppercase", letterSpacing: "0.5px" }} >
                                                                            {item.label}
                                                                        </Typography>
                                                                        <Typography variant="body2" fontWeight={600} noWrap sx={{ mt: 0.4, wordBreak: 'break-word', maxWidth: '100%', fontSize: { xs: "0.75rem", sm: "0.9rem" }, color: themeColors.neutral.black }} >
                                                                            {item.value}
                                                                        </Typography>
                                                                    </Box>
                                                                );
                                                            })}
                                                        </Box>

                                                        <IconButton size="small" onClick={() => toggleExpand(r.id)} sx={{ alignSelf: 'flex-start', flexShrink: 0, bgcolor: alpha(colors.primary.main, 0.1), color: colors.primary.main, transition: 'all 0.3s ease', "&:hover": { bgcolor: alpha(colors.primary.main, 0.2), transform: 'scale(1.1)' } }} >
                                                            {expanded ? <ExpandLessIcon sx={{ fontSize: { xs: 20, sm: 24 } }} /> : <ExpandMoreIcon sx={{ fontSize: { xs: 20, sm: 24 } }} />}
                                                        </IconButton>
                                                    </Box>

                                                    <Collapse in={expanded} timeout="auto" unmountOnExit>
                                                        <Divider sx={{ my: 1.5 }} />
                                                        <Box mt={1.5}>
                                                            {fieldGroups.map((group, gIdx) => (
                                                                <Box key={gIdx} mb={2}>
                                                                    <Typography variant="subtitle2" color="primary" gutterBottom sx={{ display: "flex", alignItems: "center", gap: 0.75, fontSize: { xs: "0.85rem", sm: "1rem" }, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px" }} >
                                                                        {group.icon} {group.title}
                                                                    </Typography>
                                                                    <Grid container spacing={{ xs: 1, sm: 1.5 }}>
                                                                        {group.fields.map((f, fIdx) => (
                                                                            <Grid item xs={12} sm={6} key={fIdx}>
                                                                                <Box sx={{ p: 1, borderRadius: 1.5, bgcolor: alpha(colors.primary.main, 0.02), border: `1px solid ${alpha(colors.primary.main, 0.1)}` }}>
                                                                                    <Typography variant="caption" sx={{ color: hasFieldError(r, f.key) ? themeColors.error.main : 'text.secondary', fontWeight: hasFieldError(r, f.key) ? 700 : 600, fontSize: { xs: "0.7rem", sm: "0.8rem" }, textTransform: "uppercase", letterSpacing: "0.3px" }} >
                                                                                        {f.label}
                                                                                    </Typography>
                                                                                    <Typography variant="body2" fontWeight={600} sx={{ fontSize: { xs: "0.8rem", sm: "0.9rem" }, mt: 0.5 }} >
                                                                                        {r[f.key] || "—"}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Grid>
                                                                        ))}
                                                                    </Grid>
                                                                </Box>
                                                            ))}
                                                        </Box>
                                                    </Collapse>
                                                </CardContent>
                                            </Card>
                                        );
                                    })
                                )}
                            </Stack>
                        </Box>
                    </GlassParentCard>
                )}
            </Box>

            <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={() => setSnackbar({ ...snackbar, open: false })} anchorOrigin={{ vertical: "top", horizontal: "center" }} >
                <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: "100%", fontSize: { xs: "0.85rem", sm: "0.95rem" }, fontWeight: 600, boxShadow: "0 4px 16px rgba(0, 0, 0, 0.15)" }} >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Container>
    );
};

export default InsertCandidate;